// 未処理のスケジュールデータの型定義
type RawScheduleData = [string, string, string][];

// 処理済みのスケジュールデータの型定義
interface ProcessedScheduleItem {
  courseCode: string;
  classroom: string;
  day: string;
  time: string;
}

// シラバスから抽出したデータ
const NotProcessedScheduleData: RawScheduleData = [
  ["E1F01001_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "水／Wed　5"],
  ["E1F01001_E2", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　5"],
  ["E1F01001_E3", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "火／Tue　5"],
  ["E1F01001_E4", "西１号館２０５・２０６／西１号館２０５・２０６", "金／Fri　5"],
  ["E1F01001_E5", "西１号館２０５・２０６／西１号館２０５・２０６", "水／Wed　5"],
  ["E1F01001_E6", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "水／Wed　5"],
  ["E1F01001_E7", "西１号館２０５・２０６／西１号館２０５・２０６", "月／Mon　5"],
  ["E1F01001_E8", "西１号館第二講義室／Room No.2，2F Bldg. West1", "水／Wed　5"],
  ["E1F01001_E9", "西１号館２０７・２０８／西１号館２０７・２０８", "金／Fri　5"],
  ["E1F01001_EA", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　5"],
  ["E1F01001_EB", "西１号館第二講義室／Room No.2，2F Bldg. West1", "火／Tue　5"],
  ["E1F01001_EC", "西１号館２０５・２０６／西１号館２０５・２０６", "火／Tue　5"],
  ["E1F01001_ED", "西１号館２０７・２０８／西１号館２０７・２０８", "水／Wed　5"],
  ["E1F01001_EE", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "金／Fri　5"],
  ["E1F01001_EF", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "月／Mon　5"],
  ["E1F01001_EG", "西１号館第一講義室／Room No.1，2F Bldg. West1", "月／Mon　5"],
  ["E1F01001_EH", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　5"],
  ["E1F01001_EI", "西１号館２０７・２０８／西１号館２０７・２０８", "月／Mon　5"],
  ["E1F01001_EJ", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "火／Tue　5"],
  ["E1F01001_EK", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "金／Fri　5"],
  ["E1F01002_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "月／Mon　5"],
  ["E1F01002_E2", "東１号館Ｅ１-２０５／E1-205", "火／Tue　5"],
  ["E1F01002_E3", "東１号館Ｅ１-１１３（旧学環）／E1-113", "水／Wed　5"],
  ["E1F01002_E4", "東１号館Ｅ１-２０５／E1-205", "金／Fri　5"],
  ["E1F01002_E5", "東１号館Ｅ１-１１３（旧学環）／E1-113", "金／Fri　5"],
  ["E1F01005_E1", "", "金／Fri　4"],
  ["E1F01006_E1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　4"],
  ["E1F01007_E1", "", "他／Otr"],
  ["E1F01008_E1", "", "他／Otr"],
  ["E1F01009_E1", "", "他／Otr"],
  ["E1F10001_E1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　3"],
  ["E1F10002_E1", "北１号館Ａ１０１, 北１号館Ａ１０４／北１号館Ａ１０１, 北１号館Ａ１０４", "水／Wed　4"],
  ["E1F10004_E1", "東１号館Ｅ１-２０１／E1-201", "木／Thu　1"],
  ["E1F10005_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　2"],
  ["E1F10006_E1", "東１号館Ｅ１-２０３／E1-203", "金／Fri　2"],
  ["E1F10011_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　3"],
  ["E1F10012_E1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　3"],
  ["E1F10016_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　3"],
  ["E1F10020_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　1"],
  ["E1F10021_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "月／Mon　1"],
  ["E1F10030_E1", "東１号館Ｅ１-３０５／E1-305", "月／Mon　3"],
  ["E1F10035_E1", "東１号館Ｅ１-１０２／E1-102", "火／Tue　2"],
  ["E1F10047_E1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　1"],
  ["E1F10060_E1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　4"],
  ["E1F10064_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "金／Fri　1"],
  ["E1F10067_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　4"],
  ["E1F10071_E1", "東１号館Ｅ１-１０２／E1-102", "木／Thu　3,　木／Thu　4"],
  ["E1F10078_E1", "", "水／Wed　4"],
  ["E1F10079_E1", "", "金／Fri　4"],
  ["E1F20003_E1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　3"],
  ["E1F20007_E1", "", "他／Otr"],
  ["E1F20008_E1", "", "月／Mon　3"],
  ["E1F20011_E1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　2"],
  ["E1F20017_E1", "", "他／Otr"],
  ["E1F20022_E1", "", "他／Otr"],
  ["E1F20023_E1", "", "他／Otr"],
  ["E1F30001_E1", "", "金／Fri　3"],
  ["E1F30002_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　3"],
  ["E1F30003_E1", "", "木／Thu　1"],
  ["E1F30004_E1", "東１号館Ｅ１-２０３／E1-203", "火／Tue　3"],
  ["E1F40003_E1", "東１号館Ｅ１-２０６／E1-206", "木／Thu　2"],
  ["E1F40006_E1", "", "他／Otr"],
  ["E1F40008_E1", "", "金／Fri　5"],
  ["E1F50009_E1", "", "他／Otr"],
  ["E1F72017_E1", "東１号館Ｅ１-１０２／E1-102", "木／Thu　3,　木／Thu　4"],
  ["E1F72018_E1", "東１号館Ｅ１-３０６／E1-306", "水／Wed　3,　水／Wed　4"],
  ["E1F72019_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "月／Mon　4"],
  ["E1F72020_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　3"],
  ["E1F72021_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "木／Thu　3"],
  ["E1F73002_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　4"],
  ["E1F75004_E1", "東１号館Ｅ１-２０３／E1-203", "木／Thu　3,　木／Thu　4"],
  ["E1F75006_E1", "東１号館Ｅ１-３０３／E1-303", "金／Fri　2"],
  ["E1F75006_E2", "東１号館Ｅ１-３０３／E1-303", "金／Fri　3"],
  ["E1F75007_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "金／Fri　2"],
  ["E1F75007_E2", "東１号館Ｅ１-１１３（旧学環）／E1-113", "金／Fri　3"],
  ["E1F75009_E1", "", "他／Otr"],
  ["E1F75010_E1", "", "他／Otr"],
  ["E1F75011_E1", "", "他／Otr"],
  ["E1F75013_E1", "", "他／Otr"],
  ["E1F79001_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "木／Thu　2"],
  ["E1F79001_E2", "西１号館第一講義室／Room No.1，2F Bldg. West1", "木／Thu　1"],
  ["E1F79001_E3", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　5"],
  ["E1F79001_E4", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "水／Wed　5"],
  ["E1F79001_E5", "図書館セミナールーム１（西５号館）／図書館セミナールーム１（西５号館）", "木／Thu　2"],
  ["E1F79001_E6", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "水／Wed　5"],
  ["E1F79001_E7", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "木／Thu　1"],
  ["E1F79001_E8", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "木／Thu　1"],
  ["E1F79001_E9", "図書館セミナールーム５（西５号館）／図書館セミナールーム５（西５号館）", "木／Thu　2"],
  ["E1F79001_EA", "図書館マルチルーム２（西５号館）／図書館マルチルーム２（西５号館）", "木／Thu　2"],
  ["E1F79001_EB", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　5"],
  ["E1F79001_EC", "西１号館第二講義室／Room No.2，2F Bldg. West1", "木／Thu　1"],
  ["E1F79001_ED", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　5"],
  ["E1F79001_EE", "西１号館２０５・２０６／西１号館２０５・２０６", "月／Mon　5"],
  ["E1F79001_EF", "西１号館２０５・２０６／西１号館２０５・２０６", "水／Wed　5"],
  ["E1F79001_EG", "東１号館Ｅ１-３０５／E1-305", "木／Thu　2"],
  ["E1F79001_EH", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "水／Wed　5"],
  ["E1F79001_EI", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　5"],
  ["E1F79001_EJ", "図書館セミナールーム３（西５号館）／図書館セミナールーム３（西５号館）", "木／Thu　2"],
  ["E1F79001_EK", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "水／Wed　5"],
  ["E1F79001_EL", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　5"],
  ["E1F79001_EM", "西１号館第二講義室／Room No.2，2F Bldg. West1", "水／Wed　5"],
  ["E1F79001_EN", "図書館セミナールーム４（西５号館）／図書館セミナールーム４（西５号館）", "木／Thu　2"],
  ["E1F79001_EO", "西１号館２０７・２０８／西１号館２０７・２０８", "水／Wed　5"],
  ["E1F79001_EP", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "木／Thu　2"],
  ["E1F79001_EQ", "図書館セミナールーム２（西５号館）／図書館セミナールーム２（西５号館）", "木／Thu　2"],
  ["E1F79001_ER", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "金／Fri　5"],
  ["E1F79001_ES", "西１号館第一講義室／Room No.1，2F Bldg. West1", "月／Mon　5"],
  ["E1F79001_ET", "図書館マルチルーム１（西５号館）／図書館マルチルーム１（西５号館）", "木／Thu　2"],
  ["E1F79001_EU", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　5"],
  ["E1F79001_EV", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "木／Thu　2"],
  ["E1F79001_EW", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　5"],
  ["E1F79001_EX", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "木／Thu　2"],
  ["E1F79001_EY", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "月／Mon　5"],
  ["E1F79001_EZ", "西１号館第一講義室／Room No.1，2F Bldg. West1", "木／Thu　2"],
  ["E1F79003_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "月／Mon　2"],
  ["E1F79003_E3", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　3"],
  ["E1F79004_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　2"],
  ["E1F79004_E2", "西１号館第一講義室／Room No.1，2F Bldg. West1", "水／Wed　2"],
  ["E1F79004_E3", "西１号館第一講義室／Room No.1，2F Bldg. West1", "月／Mon　3"],
  ["E1F79004_E5", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "金／Fri　4"],
  ["E1F79004_E6", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "木／Thu　2"],
  ["E1F79004_E7", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "火／Tue　2"],
  ["E1F79004_E8", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "水／Wed　2"],
  ["E1F79004_E9", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "木／Thu　1"],
  ["E1F79004_EA", "西１号館２０５・２０６／西１号館２０５・２０６", "水／Wed　3"],
  ["E1F79004_EB", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "月／Mon　3"],
  ["E1F79004_EC", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "火／Tue　2"],
  ["E1F79004_ED", "西１号館第一講義室／Room No.1，2F Bldg. West1", "水／Wed　4"],
  ["E1F79004_EE", "東１号館Ｅ１-２０９／E1-209", "火／Tue　4"],
  ["E1F79004_EF", "西１号館第二講義室／Room No.2，2F Bldg. West1", "火／Tue　3"],
  ["E1F79004_EG", "東１号館Ｅ１-３０１／E1-301", "金／Fri　4"],
  ["E1F79004_EH", "東１号館Ｅ１-３０５／E1-305", "金／Fri　5"],
  ["E1F79004_EJ", "西１号館２０５・２０６／西１号館２０５・２０６", "火／Tue　4"],
  ["E1F79004_EL", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "水／Wed　2"],
  ["E1F79004_EM", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "火／Tue　2"],
  ["E1F79004_EN", "西１号館第二講義室／Room No.2，2F Bldg. West1", "水／Wed　2"],
  ["E1F79004_EO", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "金／Fri　2"],
  ["E1F79004_EQ", "西１号館第二講義室／Room No.2，2F Bldg. West1", "火／Tue　4"],
  ["E1F79004_ER", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "火／Tue　5"],
  ["E1F79004_ES", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "火／Tue　2"],
  ["E1F79004_EU", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　1"],
  ["E1F79004_EW", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "金／Fri　2"],
  ["E1F79007_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "火／Tue　3"],
  ["E1F79007_E2", "西１号館第一講義室／Room No.1，2F Bldg. West1", "水／Wed　1"],
  ["E1F79007_E3", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "月／Mon　2"],
  ["E1F79007_E4", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "火／Tue　2"],
  ["E1F79007_E5", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "金／Fri　3"],
  ["E1F79007_E6", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "金／Fri　2"],
  ["E1F79007_E7", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "木／Thu　2"],
  ["E1F79007_E8", "東１号館Ｅ１-３０５／E1-305", "火／Tue　2"],
  ["E1F79007_EA", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "水／Wed　1"],
  ["E1F79007_EB", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "水／Wed　4"],
  ["E1F79007_EC", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "月／Mon　4"],
  ["E1F79007_ED", "東１号館Ｅ１-３０３／E1-303", "火／Tue　3"],
  ["E1F79007_EE", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "水／Wed　2"],
  ["E1F79007_EF", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "火／Tue　3"],
  ["E1F79007_EG", "東１号館Ｅ１-２１０／E1-210", "火／Tue　4"],
  ["E1F79007_EH", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "金／Fri　3"],
  ["E1F79007_EI", "東１号館Ｅ１-３０４／E1-304", "火／Tue　3"],
  ["E1F79007_EJ", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "火／Tue　5"],
  ["E1F79007_EK", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "木／Thu　2"],
  ["E1F79007_EL", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "火／Tue　1"],
  ["E1F79007_EM", "西１号館第二講義室／Room No.2，2F Bldg. West1", "木／Thu　2"],
  ["E1F79007_EN", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　3"],
  ["E1F79007_EO", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　2"],
  ["E1F79007_EP", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　3"],
  ["E1F79007_ER", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　2"],
  ["E1F79007_ES", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　4"],
  ["E1F79007_ET", "東１号館Ｅ１-３０６／E1-306", "火／Tue　2"],
  ["E1F79007_EU", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "金／Fri　3"],
  ["E1F79007_EV", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　4"],
  ["E1G05001_E1", "", "水／Wed　6"],
  ["E1G05002_E1", "", "水／Wed　6"],
  ["E1G05003_E1", "", "水／Wed　6"],
  ["E1G05004_E1", "", "水／Wed　6"],
  ["E1G10001_E1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　2"],
  ["E1G10002_E1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　2"],
  ["E1G10003_E1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　4"],
  ["E1G10004_E1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　4"],
  ["E1G10005_E1", "", "水／Wed　4"],
  ["E1G10006_E1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　4"],
  ["E1G10007_E1", "学術情報センター第１演習室（西５号館）, 東１号館Ｅ１-２０５／学術情報センター第１演習室（西５号館）, E1-205", "水／Wed　3"],
  ["E1G10008_E1", "東１号館Ｅ１-２０６／E1-206", "水／Wed　3"],
  ["E1G10011_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "水／Wed　4"],
  ["E1G10012_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "水／Wed　4"],
  ["E1G10013_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　3"],
  ["E1G10014_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　3"],
  ["E1G10015_E1", "", "他／Otr"],
  ["E1G10019_E1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　1"],
  ["E1G10020_E1", "東１号館Ｅ１-２０６／E1-206", "月／Mon　1"],
  ["E1G10022_E1", "", "金／Fri　2"],
  ["E1G10023_E1", "", "金／Fri　2"],
  ["E1G10024_E1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　1"],
  ["E1G10025_E1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　1"],
  ["E1G10028_E1", "", "火／Tue　3"],
  ["E1G10029_E1", "", "火／Tue　3"],
  ["E1G10030_E1", "", "火／Tue　3"],
  ["E1G10031_E1", "", "火／Tue　3"],
  ["E1G10032_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　1"],
  ["E1G10033_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　1"],
  ["E1G10034_E1", "", "木／Thu　2"],
  ["E1G10035_E1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　2"],
  ["E1G10036_E1", "", "木／Thu　1"],
  ["E1G10037_E1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　1"],
  ["E1G10040_E1", "東１号館Ｅ１-２０３／E1-203", "火／Tue　1"],
  ["E1G10041_E1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　1"],
  ["E1G10044_E1", "", "他／Otr"],
  ["E1G10045_E1", "", "他／Otr"],
  ["E1G10046_E1", "", "月／Mon　2"],
  ["E1G10047_E1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　2"],
  ["E1G10048_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　1"],
  ["E1G10049_E1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "金／Fri　3"],
  ["E1G10050_E1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　4"],
  ["E1G10051_E1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　4"],
  ["E1G10052_E1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "月／Mon　3"],
  ["E1G10053_E1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　3"],
  ["E1G10054_E1", "", "水／Wed　2"],
  ["E1G10055_E1", "東１号館Ｅ１-１０２／E1-102", "水／Wed　2"],
  ["E1G10058_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "金／Fri　1"],
  ["E1G10059_E1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　1"],
  ["E1G10060_E1", "", "火／Tue　1"],
  ["E1G10061_E1", "", "木／Thu　2"],
  ["E1G10062_E1", "東１号館Ｅ１-１０３／E1-103", "木／Thu　2"],
  ["E1G10063_E1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　1"],
  ["E1G10064_E1", "東１号館Ｅ１-１０３／E1-103", "木／Thu　1"],
  ["E1G10065_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　3"],
  ["E1G10066_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "金／Fri　3"],
  ["E1G10067_E1", "", "火／Tue　1"],
  ["E1G10068_E1", "", "火／Tue　1"],
  ["E1G10069_E1", "学術情報センター第１演習室（西５号館）, 東１号館Ｅ１-３０３／学術情報センター第１演習室（西５号館）, E1-303", "水／Wed　3"],
  ["E1G10070_E1", "学術情報センター第３演習室（西５号館）, 東１号館Ｅ１-３０３／学術情報センター第３演習室（西５号館）, E1-303", "水／Wed　3"],
  ["E1G10071_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　2"],
  ["E1G10072_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "水／Wed　2"],
  ["E1G10073_E1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "水／Wed　3"],
  ["E1G10074_E1", "東１号館Ｅ１-２０５／E1-205", "木／Thu　1"],
  ["E1G10083_E1", "東１号館Ｅ１-３０６／E1-306", "金／Fri　1"],
  ["E1G10084_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　1"],
  ["E1G10091_E1", "", "火／Tue　2"],
  ["E1G10092_E1", "", "火／Tue　2"],
  ["E1G10097_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　4"],
  ["E1G10098_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　4"],
  ["E1G10099_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　3"],
  ["E1G10100_E1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "火／Tue　3"],
  ["E1G10101_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　3"],
  ["E1G10102_E1", "", "火／Tue　4"],
  ["E1G10103_E1", "", "火／Tue　4"],
  ["E1G10104_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　4"],
  ["E1G10105_E1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "火／Tue　3"],
  ["E1G10106_E1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　2"],
  ["E1G10107_E1", "東１号館Ｅ１-３０３／E1-303", "月／Mon　2"],
  ["E1G10108_E1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　2"],
  ["E1G10109_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　2"],
  ["E1G10110_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　4"],
  ["E1G10111_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "火／Tue　4"],
  ["E1G20001_E1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "水／Wed　4"],
  ["E1G20002_E1", "東１号館Ｅ１-１０２／E1-102", "水／Wed　4"],
  ["E1G20003_E1", "", "木／Thu　1"],
  ["E1G20006_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　2"],
  ["E1G20007_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　2"],
  ["E1G20008_E1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　2"],
  ["E1G20009_E1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "火／Tue　2"],
  ["E1G20010_E1", "東３号館中４０８／東３号館中４０８", "木／Thu　2"],
  ["E1G20011_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "木／Thu　2"],
  ["E1G20012_E1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　3"],
  ["E1G20013_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "水／Wed　3"],
  ["E1G20014_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　4"],
  ["E1G20015_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　4"],
  ["E1G20016_E1", "", "木／Thu　2"],
  ["E1G20017_E1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　5"],
  ["E1G20018_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "火／Tue　4"],
  ["E1G20019_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "火／Tue　4"],
  ["E1G20020_E1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　3"],
  ["E1G20021_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "火／Tue　2"],
  ["E1G20022_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　2"],
  ["E1G20023_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "月／Mon　3"],
  ["E1G30001_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　1"],
  ["E1G30002_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　1"],
  ["E1G30003_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "金／Fri　1"],
  ["E1G30004_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　1"],
  ["E1G30005_E1", "東１号館Ｅ１-２０６／E1-206", "火／Tue　1"],
  ["E1G30006_E1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　1"],
  ["E1G30007_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "火／Tue　1"],
  ["E1G30008_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　1"],
  ["E1G30009_E1", "東１号館Ｅ１-３０３／E1-303", "火／Tue　4"],
  ["E1G30010_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "金／Fri　4"],
  ["E1G30011_E1", "", "火／Tue　2"],
  ["E1G30012_E1", "", "火／Tue　2"],
  ["E1G30013_E1", "", "火／Tue　2"],
  ["E1G30014_E1", "", "火／Tue　2"],
  ["E1G30015_E1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　5"],
  ["E1G30019_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　2"],
  ["E1G30020_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　3"],
  ["E1G30021_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　2"],
  ["E1G30022_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　3"],
  ["E1G30023_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　3"],
  ["E1G30024_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　3"],
  ["E1G30025_E1", "東１号館Ｅ１-３０１／E1-301", "木／Thu　2"],
  ["E1G30026_E1", "図書館セミナールーム１（西５号館）／図書館セミナールーム１（西５号館）", "木／Thu　2"],
  ["E1G40001_E1", "", "金／Fri　6"],
  ["E1G40002_E1", "", "金／Fri　6"],
  ["E1G40003_E1", "東１号館Ｅ１-２０３／E1-203", "月／Mon　4"],
  ["E1G40004_E1", "東１号館Ｅ１-２０８／E1-208", "月／Mon　4"],
  ["E1G40005_E1", "", "金／Fri　5"],
  ["E1G40006_E1", "", "金／Fri　5"],
  ["E1G40007_E1", "東１号館Ｅ１-１０２／E1-102", "金／Fri　3"],
  ["E1G40008_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "金／Fri　3"],
  ["E1G40012_E1", "", "金／Fri　6"],
  ["E1G40013_E1", "", "金／Fri　6"],
  ["E1G50003_E1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　1"],
  ["E1G50004_E1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　1"],
  ["E1G50005_E1", "東１号館Ｅ１-１０２／E1-102", "火／Tue　3"],
  ["E1G50006_E1", "東１号館Ｅ１-１０２／E1-102", "火／Tue　3"],
  ["E1G50007_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "火／Tue　3"],
  ["E1G50008_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "火／Tue　3"],
  ["E1G50009_E1", "東２号館Ｌ２０２／東２号館Ｌ２０２", "水／Wed　3"],
  ["E1G50010_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　3"],
  ["E1G50013_E1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　4"],
  ["E1G50014_E1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　4"],
  ["E1G50017_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　2"],
  ["E1G50018_E1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　2"],
  ["E1G50019_E1", "東１号館Ｅ１-２０３／E1-203", "月／Mon　3"],
  ["E1G50020_E1", "東１号館Ｅ１-２０３／E1-203", "月／Mon　3"],
  ["E1G50021_E1", "東１号館Ｅ１-２０３／E1-203", "水／Wed　1"],
  ["E1G50022_E1", "東１号館Ｅ１-２０３／E1-203", "水／Wed　1"],
  ["E1G50023_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "月／Mon　4"],
  ["E1G50024_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　4"],
  ["E1G50025_E1", "東１号館Ｅ１-２０１／E1-201", "水／Wed　1"],
  ["E1G50027_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "月／Mon　3"],
  ["E1G50028_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "月／Mon　3"],
  ["E1G50035_E1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　2"],
  ["E1G50036_E1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　2"],
  ["E1G50043_E1", "東１号館Ｅ１-２０３／E1-203", "水／Wed　2"],
  ["E1G50044_E1", "東２号館Ｌ２０２／東２号館Ｌ２０２", "水／Wed　2"],
  ["E1G50045_E1", "東１号館Ｅ１-２０６／E1-206", "水／Wed　3"],
  ["E1G50046_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "水／Wed　4"],
  ["E1G50052_E1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　1"],
  ["E1G50055_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "木／Thu　1"],
  ["E1G50056_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "木／Thu　1"],
  ["E1G50057_E1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　4"],
  ["E1G50058_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　1"],
  ["E1G50059_E1", "東１号館Ｅ１-２０５／E1-205", "月／Mon　1"],
  ["E1G71001_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "木／Thu　1"],
  ["E1G71002_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "木／Thu　1"],
  ["E1G71003_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "金／Fri　2"],
  ["E1G71004_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "金／Fri　2"],
  ["E1G71005_E1", "", "木／Thu　5"],
  ["E1G71006_E1", "東１号館Ｅ１-１０３／E1-103", "木／Thu　4"],
  ["E1G71009_E1", "東１号館Ｅ１-３０５／E1-305", "月／Mon　5"],
  ["E1G71010_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　5"],
  ["E1G75001_E1", "", "他／Otr"],
  ["E1G75002_E1", "", "他／Otr"],
  ["E1G75003_E1", "", "他／Otr"],
  ["E1G75004_E1", "", "他／Otr"],
  ["E1G77001_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "水／Wed　4"],
  ["E1G77002_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "水／Wed　4"],
  ["E1G77003_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　3"],
  ["E1G77004_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "水／Wed　3"],
  ["E2F00001_E1", "東１号館Ｅ１-３０５／E1-305", "木／Thu　4,　木／Thu　5"],
  ["E2F00001_E2", "東１号館Ｅ１-１１３（旧学環）／E1-113", "木／Thu　4,　木／Thu　5"],
  ["E2F00002_E1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "木／Thu　3,　木／Thu　4"],
  ["E2F00002_E2", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "木／Thu　3,　木／Thu　4"],
  ["E2F00003_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　5"],
  ["E2F00005_E1", "東１号館Ｅ１-２０３／E1-203", "木／Thu　3,　木／Thu　4"],
  ["E2F00006_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "火／Tue　1"],
  ["E2F00009_E1", "", "木／Thu　5"],
  ["E2F05003_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "月／Mon　2"],
  ["E2F05004_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "月／Mon　2"],
  ["E2F05005_E1", "", "他／Otr"],
  ["E2F05006_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　3"],
  ["E2F05007_E1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "火／Tue　4"],
  ["E2F05010_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　3"],
  ["E2F05012_E1", "", "他／Otr"],
  ["E2F11001_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "金／Fri　2"],
  ["E2F11002_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "金／Fri　3"],
  ["E2F11003_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　2"],
  ["E2F11004_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "金／Fri　3"],
  ["E2F11007_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "金／Fri　3"],
  ["E2F11008_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "金／Fri　4"],
  ["E2F12001_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "火／Tue　4"],
  ["E2F12002_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "火／Tue　3"],
  ["E2F12003_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "火／Tue　3"],
  ["E2F12004_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "木／Thu　2"],
  ["E2F12005_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "水／Wed　1"],
  ["E2F12006_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　1"],
  ["E2F13001_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　4"],
  ["E2F13002_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "火／Tue　5"],
  ["E2F13003_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "木／Thu　2"],
  ["E2F13004_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　4"],
  ["E2F13005_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　5"],
  ["E2F13006_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　3"],
  ["E2F13007_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　3"],
  ["E2F14003_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　3"],
  ["E2F14004_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "火／Tue　2"],
  ["E2F14005_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "水／Wed　3"],
  ["E2F15001_E1", "東１号館Ｅ１-３０３／E1-303", "火／Tue　5"],
  ["E2F15002_E2", "", "他／Otr"],
  ["E2F15003_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　5"],
  ["E2F15004_E1", "", "他／Otr"],
  ["E2F15005_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "火／Tue　3"],
  ["E2F15006_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "月／Mon　5"],
  ["E2F15007_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "火／Tue　2"],
  ["E2F15008_E1", "", "他／Otr"],
  ["E2F16001_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "水／Wed　3"],
  ["E2F16002_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "月／Mon　2"],
  ["E2F16003_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "金／Fri　5"],
  ["E2F16004_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　1"],
  ["E2F17001_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　2"],
  ["E2F17002_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "水／Wed　3"],
  ["E2F17003_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "金／Fri　3"],
  ["E2F17005_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　3"],
  ["E2F17006_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "火／Tue　2"],
  ["E2F17007_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "火／Tue　4"],
  ["E2F17008_E1", "", "他／Otr"],
  ["E2F18003_E1", "", "他／Otr"],
  ["E2F21001_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　3"],
  ["E2F21002_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "水／Wed　3"],
  ["E2F21003_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　4"],
  ["E2F21004_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　2"],
  ["E2F21006_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "木／Thu　1"],
  ["E2F22001_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "火／Tue　3"],
  ["E2F22002_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　5"],
  ["E2F22003_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "火／Tue　4"],
  ["E2F22004_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　5"],
  ["E2F23001_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　5"],
  ["E2F23002_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "木／Thu　2"],
  ["E2F23003_E1", "", "他／Otr"],
  ["E2F23004_E1", "西１号館２０５・２０６／西１号館２０５・２０６", "月／Mon　4"],
  ["E2F24003_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　2"],
  ["E2F24004_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "木／Thu　2"],
  ["E2F24005_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "水／Wed　4"],
  ["E2F24007_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "木／Thu　2"],
  ["E2F24008_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　2"],
  ["E2F24009_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "水／Wed　3"],
  ["E2F24010_E1", "東１号館Ｅ１-２０１／E1-201", "火／Tue　2"],
  ["E2F24013_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "水／Wed　5"],
  ["E2F25003_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "金／Fri　5"],
  ["E2F25004_E1", "東１号館Ｅ１-２０１／E1-201", "火／Tue　3"],
  ["E2F25005_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "火／Tue　2"],
  ["E2F25006_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　3"],
  ["E2F25007_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "水／Wed　4"],
  ["E2F25008_E1", "", "他／Otr"],
  ["E2F25009_E1", "西３号館１０５（コミュニケーションⅠ）／西３号館１０５（コミュニケーションⅠ）", "木／Thu　2"],
  ["E2F26001_E1", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "水／Wed　3"],
  ["E2F26002_E1", "", "他／Otr"],
  ["E2F26003_E1", "西１号館第二講義室／Room No.2，2F Bldg. West1", "火／Tue　5"],
  ["E2F26004_E1", "東１号館Ｅ１-１１２（面談室）／E1-112", "木／Thu　2"],
  ["E2F26007_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　2"],
  ["E2F27001_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "月／Mon　2"],
  ["E2F27002_E1", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "月／Mon　4"],
  ["E2F27003_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　3"],
  ["E2F27004_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "金／Fri　3"],
  ["E2F27006_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "月／Mon　2"],
  ["E2F27007_E1", "", "火／Tue　4"],
  ["E2F27008_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "水／Wed　3"],
  ["E2F27009_E1", "", "他／Otr"],
  ["E2F27010_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　4"],
  ["E2F28001_E1", "", "他／Otr"],
  ["E2F28002_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "水／Wed　1"],
  ["E2F28003_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "水／Wed　3"],
  ["E2F28005_E1", "", "他／Otr"],
  ["E2F28006_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "金／Fri　2"],
  ["E2F28007_E1", "西１号館２０７・２０８／西１号館２０７・２０８", "金／Fri　1"],
  ["E2F31001_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "金／Fri　4"],
  ["E2F31002_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "金／Fri　2"],
  ["E2F32001_E1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "水／Wed　3,　水／Wed　4"],
  ["E2F32002_E1", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "火／Tue　5"],
  ["E2F33001_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "月／Mon　5"],
  ["E2F33002_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "木／Thu　1"],
  ["E2F34002_E1", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　2"],
  ["E2F34003_E1", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "木／Thu　1"],
  ["E2F34004_E1", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "木／Thu　1"],
  ["E2F35001_E1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "金／Fri　3,　金／Fri　4"],
  ["E2F36001_E1", "", "他／Otr"],
  ["E2F36002_E1", "", "他／Otr"],
  ["E2F37001_E1", "", "他／Otr"],
  ["E2F38001_E1", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "水／Wed　4"],
  ["E2F38002_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "水／Wed　3"],
  ["E2F91003_E7", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "火／Tue　1"],
  ["E2F91003_EA", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "木／Thu　2"],
  ["E2F91003_EE", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　5"],
  ["E2F91003_EJ", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　4"],
  ["E2F91004_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "金／Fri　4"],
  ["E2F91004_E2", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　1"],
  ["E2F91004_E3", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "水／Wed　2"],
  ["E2F91004_E5", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　3"],
  ["E2F91004_E6", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "火／Tue　4"],
  ["E2F91004_E7", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　2"],
  ["E2F91004_E9", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　5"],
  ["E2F91004_EB", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "月／Mon　1"],
  ["E2F91004_EC", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "金／Fri　5"],
  ["E2F91004_ED", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "木／Thu　1"],
  ["E2F91004_EF", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　4"],
  ["E2F91004_EG", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "木／Thu　1"],
  ["E2F91004_EH", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　4"],
  ["E2F91004_EM", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "火／Tue　3"],
  ["E2F91004_EO", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "火／Tue　1"],
  ["E2F91004_EQ", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "火／Tue　5"],
  ["E2F91004_EU", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "金／Fri　1"],
  ["E2F91004_EV", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "金／Fri　5"],
  ["E2F91005_E1", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "金／Fri　4"],
  ["E2F91005_E2", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "火／Tue　1"],
  ["E2F91005_E3", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "水／Wed　2"],
  ["E2F91005_E5", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "火／Tue　3"],
  ["E2F91005_E6", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "月／Mon　3"],
  ["E2F91005_E7", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "水／Wed　2"],
  ["E2F91005_E9", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　5"],
  ["E2F91005_EB", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "金／Fri　1"],
  ["E2F91005_EC", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "金／Fri　5"],
  ["E2F91005_ED", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "木／Thu　1"],
  ["E2F91005_EF", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "水／Wed　4"],
  ["E2F91005_EG", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "木／Thu　1"],
  ["E2F91005_EH", "西３号館２１０（研究室１）／西３号館２１０（研究室１）", "火／Tue　4"],
  ["E2F91005_EM", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "火／Tue　3"],
  ["E2F91005_EO", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　4"],
  ["E2F91005_EQ", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "火／Tue　5"],
  ["E2F91005_EU", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "金／Fri　1"],
  ["E2F91005_EV", "西３号館２０２（学部生支援室）／西３号館２０２（学部生支援室）", "金／Fri　5"],
  ["E2F91006_E1", "西１号館第一講義室／Room No.1，2F Bldg. West1", "火／Tue　3"],
  ["E2F91006_E2", "西３号館２０６（産官学連携室）／西３号館２０６（産官学連携室）", "金／Fri　1"],
  ["E2F91006_E3", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "水／Wed　4"],
  ["E2F91006_E4", "西３号館２０７（研究室２）／西３号館２０７（研究室２）", "火／Tue　1"],
  ["E2F91006_E5", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "金／Fri　4"],
  ["E2F91006_E6", "西３号館２０９（研究室３）／西３号館２０９（研究室３）", "火／Tue　5"],
  ["E2F91006_E7", "西３号館１０８（コミュニケーションⅡ）／西３号館１０８（コミュニケーションⅡ）", "火／Tue　4"],
  ["E2F91006_E8", "西３号館２０８（研究室４）／西３号館２０８（研究室４）", "月／Mon　1"],
  ["E2F91006_E9", "西１号館２０７・２０８／西１号館２０７・２０８", "火／Tue　4"],
  ["E2F91006_EA", "西１号館２０５・２０６／西１号館２０５・２０６", "木／Thu　1"],
  ["E2F91006_EB", "", "他／Otr"],
  ["E2F91006_EC", "", "他／Otr"],
  ["G1000055_G1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　2"],
  ["G1000064_G1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "火／Tue　2"],
  ["G1000151_G1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　2"],
  ["G1000197_G1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　2"],
  ["G1000244_G1", "東１号館Ｅ１-３０３／E1-303", "水／Wed　2"],
  ["G1000365_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　4"],
  ["G1000551_G1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　2"],
  ["G1000617_G1", "東１号館Ｅ１-１０３／E1-103", "金／Fri　4"],
  ["G1000628_G1", "東１号館Ｅ１-１０３／E1-103", "木／Thu　3"],
  ["G1000631_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　3"],
  ["G1000631_G2", "東１号館Ｅ１-２０６／E1-206", "木／Thu　2"],
  ["G1000632_G1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　4"],
  ["G1000655_G1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　3"],
  ["G1000662_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　4"],
  ["G1000665_G1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　3"],
  ["G1000674_G1", "東１号館Ｅ１-２０９／E1-209", "金／Fri　3"],
  ["G1000677_G1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　3"],
  ["G1000689_G1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　3"],
  ["G1000691_G1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　4"],
  ["G1000728_G1", "東１号館Ｅ１-２０８／E1-208", "火／Tue　3"],
  ["G1000729_G1", "東１号館Ｅ１-２１０／E1-210", "木／Thu　2"],
  ["G1000767_G1", "東１号館Ｅ１-３０４／E1-304", "月／Mon　1"],
  ["G1000767_G2", "東１号館Ｅ１-３０４／E1-304", "月／Mon　2"],
  ["G1000767_G3", "東１号館Ｅ１-３０４／E1-304", "月／Mon　3"],
  ["G1000767_G4", "東１号館Ｅ１-３０４／E1-304", "月／Mon　4"],
  ["G1000768_G1", "東１号館Ｅ１-３０４／E1-304", "金／Fri　1"],
  ["G1000768_G2", "東１号館Ｅ１-３０４／E1-304", "金／Fri　2"],
  ["G1000768_G4", "東１号館Ｅ１-３０５／E1-305", "金／Fri　1"],
  ["G1000768_G5", "東１号館Ｅ１-３０５／E1-305", "金／Fri　2"],
  ["G1000769_G1", "東１号館Ｅ１-３０４／E1-304", "月／Mon　1"],
  ["G1000769_G2", "東１号館Ｅ１-３０４／E1-304", "月／Mon　2"],
  ["G1000769_G3", "東１号館Ｅ１-３０４／E1-304", "月／Mon　3"],
  ["G1000769_G4", "東１号館Ｅ１-３０４／E1-304", "月／Mon　4"],
  ["G1000770_G1", "東１号館Ｅ１-３０４／E1-304", "金／Fri　1"],
  ["G1000770_G2", "東１号館Ｅ１-３０４／E1-304", "金／Fri　2"],
  ["G1000770_G4", "東１号館Ｅ１-３０５／E1-305", "金／Fri　1"],
  ["G1000770_G5", "東１号館Ｅ１-３０５／E1-305", "金／Fri　2"],
  ["G1000771_G1", "東１号館Ｅ１-２０１／E1-201", "月／Mon　3"],
  ["G1000771_G2", "東１号館Ｅ１-２０１／E1-201", "月／Mon　4"],
  ["G1000771_G3", "東１号館Ｅ１-２０１／E1-201", "火／Tue　1"],
  ["G1000771_G4", "東１号館Ｅ１-２０１／E1-201", "火／Tue　2"],
  ["G1000773_G1", "東１号館Ｅ１-３０１／E1-301", "火／Tue　1"],
  ["G1000773_G2", "東１号館Ｅ１-３０１／E1-301", "火／Tue　2"],
  ["G1000773_G3", "東１号館Ｅ１-３０１／E1-301", "木／Thu　1"],
  ["G1000773_G4", "東１号館Ｅ１-３０１／E1-301", "木／Thu　2"],
  ["G1000776_G1", "東１号館Ｅ１-１０２／E1-102", "火／Tue　2"],
  ["G1000778_G1", "東１号館Ｅ１-２１０／E1-210", "月／Mon　4"],
  ["G1000855_G1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　2"],
  ["G1001001_G1", "東１号館Ｅ１-１０１, 東１号館Ｅ１-１０２, 東１号館Ｅ１-１０３, 東２号館Ｌ１０１／E1-101, E1-102, E1-103, 東２号館Ｌ１０１", "木／Thu　1"],
  ["G1001007_G1", "東１号館Ｅ１-１０２／E1-102", "水／Wed　1"],
  ["G1001010_G1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　1"],
  ["G1001011_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　2"],
  ["G1001012_G1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　2"],
  ["G1001016_G1", "東１号館Ｅ１-１０２／E1-102", "火／Tue　1"],
  ["G1001017_G1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　1"],
  ["G1001018_G1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　2"],
  ["G1001021_G1", "東１号館Ｅ１-１０３／E1-103", "火／Tue　1"],
  ["G1001023_G1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　1"],
  ["G1001025_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　1"],
  ["G1001026_G1", "東１号館Ｅ１-１０２／E1-102", "水／Wed　1"],
  ["G1001028_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　2"],
  ["G1001029_G1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　2"],
  ["G1001030_G1", "東１号館Ｅ１-１０２／E1-102", "水／Wed　2"],
  ["G1001032_G1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　2"],
  ["G1001039_G1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　3"],
  ["G1001040_G1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　3"],
  ["G1001043_G1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　3"],
  ["G1001045_G1", "", "木／Thu　6"],
  ["G1001045_G2", "", "木／Thu　6"],
  ["G1001046_G1", "", "木／Thu　6"],
  ["G1001046_G2", "", "木／Thu　6"],
  ["G1001047_G1", "", "木／Thu　6"],
  ["G1001048_G1", "", "木／Thu　6"],
  ["G1001049_G1", "", "金／Fri　2"],
  ["G1001049_G2", "", "金／Fri　3"],
  ["G1001049_G4", "", "月／Mon　6"],
  ["G1001049_G5", "", "火／Tue　6"],
  ["G1001049_G6", "", "火／Tue　6"],
  ["G1001049_G7", "", "木／Thu　3"],
  ["G1001049_G8", "", "他／Otr"],
  ["G1001049_G9", "", "木／Thu　3"],
  ["G1001049_Gd", "", "月／Mon　6"],
  ["G1001050_G1", "", "金／Fri　2"],
  ["G1001050_G2", "", "金／Fri　3"],
  ["G1001050_G4", "", "月／Mon　6"],
  ["G1001050_G5", "", "火／Tue　6"],
  ["G1001050_G6", "", "火／Tue　6"],
  ["G1001050_G7", "", "木／Thu　3"],
  ["G1001050_G8", "", "他／Otr"],
  ["G1001050_G9", "", "木／Thu　3"],
  ["G1001050_Gd", "", "月／Mon　6"],
  ["G1001051_G1", "", "月／Mon　6"],
  ["G1001051_G4", "", "他／Otr"],
  ["G1001051_G5", "", "木／Thu　4"],
  ["G1001051_G6", "", "木／Thu　4"],
  ["G1001052_G1", "", "月／Mon　6"],
  ["G1001052_G4", "", "他／Otr"],
  ["G1001052_G5", "", "木／Thu　4"],
  ["G1001052_G6", "", "木／Thu　4"],
  ["G1001054_G1", "東１号館Ｅ１-２０６／E1-206", "火／Tue　4"],
  ["G1001054_G2", "東１号館Ｅ１-１０２／E1-102", "火／Tue　4"],
  ["G1001056_G1", "", "他／Otr"],
  ["G1001057_G1", "", "他／Otr"],
  ["G1001063_G1", "東１号館Ｅ１-２０８／E1-208", "木／Thu　4"],
  ["G1001064_G1", "東１号館Ｅ１-２０８／E1-208", "火／Tue　4"],
  ["G1001070_G1", "東１号館Ｅ１-２０６／E1-206", "火／Tue　4"],
  ["G1001070_G2", "東１号館Ｅ１-１０２／E1-102", "火／Tue　4"],
  ["G1001076_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　3"],
  ["G1001080_G1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　3"],
  ["G1001081_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　1"],
  ["G1001082_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　1"],
  ["G1001083_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　1"],
  ["G1001084_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　1"],
  ["G1001085_G1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　2"],
  ["G1001085_G2", "東１号館Ｅ１-１０２／E1-102", "月／Mon　2"],
  ["G1001086_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　2"],
  ["G1001087_G1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　4"],
  ["G1001087_G2", "東１号館Ｅ１-２０５／E1-205", "金／Fri　3"],
  ["G1001088_G1", "東１号館Ｅ１-２０５／E1-205", "月／Mon　3"],
  ["G1001088_G2", "東１号館Ｅ１-２０５／E1-205", "金／Fri　2"],
  ["G1001089_G1", "東１号館Ｅ１-２０３／E1-203", "火／Tue　2"],
  ["G1001090_G1", "東１号館Ｅ１-３０５／E1-305", "木／Thu　3"],
  ["G1001090_G2", "東１号館Ｅ１-３０５／E1-305", "木／Thu　2"],
  ["G1001091_G1", "", "他／Otr"],
  ["G1001092_G1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　1"],
  ["G1001093_G1", "", "他／Otr"],
  ["G1001094_G1", "", "他／Otr"],
  ["G1001095_G1", "東１号館Ｅ１-３０５／E1-305", "木／Thu　2"],
  ["G1001096_G1", "東１号館Ｅ１-３０５／E1-305", "木／Thu　3"],
  ["G2001001_G1", "東１号館Ｅ１-３０１／E1-301", "木／Thu　3"],
  ["G2001002_G1", "東１号館Ｅ１-３０６／E1-306", "木／Thu　3"],
  ["G2001003_G1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　3"],
  ["G2001004_G1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　4"],
  ["G2001006_G1", "東１号館Ｅ１-３０１／E1-301", "木／Thu　4"],
  ["G2001007_G1", "東１号館Ｅ１-２０９／E1-209", "木／Thu　4"],
  ["G2001008_G1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　4"],
  ["G2001009_G1", "東１号館Ｅ１-３０１／E1-301", "木／Thu　4"],
  ["G2001010_G1", "東１号館Ｅ１-２１０／E1-210", "木／Thu　3"],
  ["G2001011_G1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　3"],
  ["G2001012_G1", "東１号館Ｅ１-２０９／E1-209", "木／Thu　3"],
  ["G2001013_G1", "東１号館Ｅ１-２１０／E1-210", "月／Mon　1"],
  ["G2001013_G2", "東１号館Ｅ１-２１０／E1-210", "月／Mon　2"],
  ["G2001013_G3", "東１号館Ｅ１-２０８／E1-208", "月／Mon　3"],
  ["G2001013_G4", "東１号館Ｅ１-２０８／E1-208", "月／Mon　2"],
  ["G2001013_G5", "東１号館Ｅ１-２１０／E1-210", "月／Mon　3"],
  ["G2001013_G8", "東１号館Ｅ１-３０６／E1-306", "月／Mon　2"],
  ["G2001013_G9", "東１号館Ｅ１-２０９／E1-209", "月／Mon　3"],
  ["G2001013_Ga", "東１号館Ｅ１-３０１／E1-301", "月／Mon　2"],
  ["G2001013_Gb", "東１号館Ｅ１-３０１／E1-301", "月／Mon　3"],
  ["G2001013_Gc", "東１号館Ｅ１-２０６／E1-206", "月／Mon　4"],
  ["G2001014_G1", "東１号館Ｅ１-２１０／E1-210", "月／Mon　1"],
  ["G2001014_G2", "東１号館Ｅ１-２１０／E1-210", "月／Mon　2"],
  ["G2001014_G3", "東１号館Ｅ１-２０８／E1-208", "月／Mon　3"],
  ["G2001014_G4", "東１号館Ｅ１-２０８／E1-208", "月／Mon　2"],
  ["G2001014_G5", "東１号館Ｅ１-２１０／E1-210", "月／Mon　3"],
  ["G2001014_G8", "東１号館Ｅ１-３０６／E1-306", "月／Mon　2"],
  ["G2001014_G9", "東１号館Ｅ１-３０１／E1-301", "月／Mon　3"],
  ["G2001014_Ga", "東１号館Ｅ１-２０１／E1-201", "月／Mon　2"],
  ["G2001014_Gb", "東１号館Ｅ１-２０１／E1-201", "月／Mon　3"],
  ["G2001014_Gc", "東１号館Ｅ１-２０１／E1-201", "月／Mon　4"],
  ["G2001015_G2", "東１号館Ｅ１-３０１／E1-301", "木／Thu　3"],
  ["G2001015_G3", "東１号館Ｅ１-３０５／E1-305", "月／Mon　1"],
  ["G2001015_G4", "東１号館Ｅ１-３０５／E1-305", "月／Mon　2"],
  ["G2001015_G5", "東１号館Ｅ１-２０８／E1-208", "木／Thu　3"],
  ["G2001016_G2", "東１号館Ｅ１-２０９／E1-209", "木／Thu　3"],
  ["G2001016_G3", "東１号館Ｅ１-２０８／E1-208", "月／Mon　1"],
  ["G2001016_G4", "東１号館Ｅ１-３０５／E1-305", "月／Mon　2"],
  ["G2001016_G5", "東１号館Ｅ１-２０８／E1-208", "木／Thu　4"],
  ["G2001017_G1", "東１号館Ｅ１-３０５／E1-305", "金／Fri　3"],
  ["G2001019_G1", "東１号館Ｅ１-２１０／E1-210", "火／Tue　1"],
  ["G2001020_G1", "東１号館Ｅ１-２０１／E1-201", "木／Thu　3"],
  ["G2001021_G1", "東１号館Ｅ１-２０１／E1-201", "金／Fri　3"],
  ["G2001022_G1", "東１号館Ｅ１-２１０／E1-210", "火／Tue　1"],
  ["G2002001_G1", "東１号館Ｅ１-２０５／E1-205", "火／Tue　4"],
  ["G2002001_G2", "東１号館Ｅ１-２０６／E1-206", "木／Thu　3"],
  ["G2002001_G3", "東１号館Ｅ１-２０８／E1-208", "火／Tue　4"],
  ["G2002002_G2", "東１号館Ｅ１-２０６／E1-206", "木／Thu　3"],
  ["G2003001_G1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　2"],
  ["G2003001_G2", "東１号館Ｅ１-２０１／E1-201", "火／Tue　4"],
  ["G2003001_G3", "東１号館Ｅ１-２０１／E1-201", "火／Tue　4"],
  ["G2003002_G1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　2"],
  ["G2004001_G1", "東１号館Ｅ１-３０３／E1-303", "木／Thu　2"],
  ["G2004001_G2", "東１号館Ｅ１-３０３／E1-303", "木／Thu　3"],
  ["G2004001_G3", "東１号館Ｅ１-２０５／E1-205", "木／Thu　2"],
  ["G2004001_G4", "東１号館Ｅ１-２０５／E1-205", "木／Thu　3"],
  ["G2004001_G5", "東１号館Ｅ１-２０５／E1-205", "木／Thu　2"],
  ["G2004002_G1", "東１号館Ｅ１-３０３／E1-303", "木／Thu　2"],
  ["G2004002_G2", "東１号館Ｅ１-３０３／E1-303", "木／Thu　3"],
  ["G2004002_G3", "東１号館Ｅ１-２０５／E1-205", "木／Thu　3"],
  ["G2005001_G1", "東１号館Ｅ１-２０３／E1-203", "木／Thu　2"],
  ["G2005001_G2", "東１号館Ｅ１-２０３／E1-203", "火／Tue　4"],
  ["G2005001_G3", "東１号館Ｅ１-２０３／E1-203", "火／Tue　4"],
  ["G2005002_G1", "東１号館Ｅ１-２０３／E1-203", "木／Thu　2"],
  ["G2006009_G1", "東１号館Ｅ１-２０９／E1-209", "火／Tue　3"],
  ["G2006010_G1", "東１号館Ｅ１-２１０／E1-210", "水／Wed　2"],
  ["G2006011_G1", "東１号館Ｅ１-２０９／E1-209", "火／Tue　3"],
  ["G2006012_G1", "東１号館Ｅ１-２１０／E1-210", "水／Wed　2"],
  ["G2006013_G1", "東１号館Ｅ１-２１０／E1-210", "火／Tue　2"],
  ["G2006014_G1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　3"],
  ["G2006015_G1", "東１号館Ｅ１-２０９／E1-209", "火／Tue　2"],
  ["G2006016_G1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　3"],
  ["G2006017_G1", "東１号館Ｅ１-２１０／E1-210", "火／Tue　3"],
  ["G2006018_G1", "東１号館Ｅ１-２０６／E1-206", "水／Wed　2"],
  ["G2006019_G1", "東１号館Ｅ１-２０８／E1-208", "火／Tue　3"],
  ["G2006020_G1", "東１号館Ｅ１-２０６／E1-206", "水／Wed　2"],
  ["G2006021_G1", "東１号館Ｅ１-３０１／E1-301", "火／Tue　2"],
  ["G2006022_G1", "東１号館Ｅ１-２０９／E1-209", "水／Wed　3"],
  ["G2006023_G1", "東１号館Ｅ１-２１０／E1-210", "火／Tue　2"],
  ["G2006024_G1", "東１号館Ｅ１-２０９／E1-209", "水／Wed　3"],
  ["G2006028_G1", "東１号館Ｅ１-２０９／E1-209", "火／Tue　2"],
  ["G2006029_G1", "東１号館Ｅ１-３０１／E1-301", "火／Tue　3"],
  ["G2006030_G1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　2"],
  ["G2006031_G1", "東１号館Ｅ１-２１０／E1-210", "水／Wed　3"],
  ["G2006032_G1", "東１号館Ｅ１-２０８／E1-208", "火／Tue　2"],
  ["G2006033_G1", "東１号館Ｅ１-２１０／E1-210", "火／Tue　3"],
  ["G2006034_G1", "東１号館Ｅ１-２０１／E1-201", "水／Wed　2"],
  ["G2006035_G1", "東１号館Ｅ１-２１０／E1-210", "水／Wed　3"],
  ["G2L00303_G1", "東１号館Ｅ１-２０９／E1-209", "金／Fri　1"],
  ["G2L10099_G1", "東１号館Ｅ１-３０１／E1-301", "水／Wed　3"],
  ["G2L10100_G1", "東１号館Ｅ１-２０６／E1-206", "水／Wed　3"],
  ["G2L10101_G1", "東１号館Ｅ１-２１０／E1-210", "金／Fri　3"],
  ["G2L10107_G1", "東１号館Ｅ１-２０１／E1-201", "水／Wed　3"],
  ["G2L10115_G1", "東１号館Ｅ１-３０５／E1-305", "水／Wed　3"],
  ["G2L10116_G1", "東１号館Ｅ１-３０５／E1-305", "水／Wed　3"],
  ["G2L10117_G1", "東１号館Ｅ１-３０６／E1-306", "金／Fri　3"],
  ["G2L10118_G1", "東１号館Ｅ１-３０６／E1-306", "金／Fri　1"],
  ["G2L10125_G1", "東１号館Ｅ１-２０９／E1-209", "金／Fri　3"],
  ["G2L10132_G1", "東１号館Ｅ１-３０１／E1-301", "水／Wed　3"],
  ["G2L10133_G1", "東１号館Ｅ１-２０８／E1-208", "金／Fri　3"],
  ["G2L10134_G1", "東１号館Ｅ１-２０８／E1-208", "金／Fri　1"],
  ["G2L10139_G1", "東１号館Ｅ１-３０４／E1-304", "水／Wed　3"],
  ["G2L10140_G1", "東１号館Ｅ１-３０４／E1-304", "水／Wed　3"],
  ["G2L10141_G1", "東１号館Ｅ１-３０４／E1-304", "金／Fri　3"],
  ["G2L10142_G1", "東１号館Ｅ１-２１０／E1-210", "金／Fri　1"],
  ["G2L80048_G1", "東１号館Ｅ１-３０１／E1-301", "金／Fri　3"],
  ["G2L80050_G1", "東１号館Ｅ１-２０１／E1-201", "金／Fri　1"],
  ["G2S10014_G1", "東１号館Ｅ１-３０１／E1-301", "金／Fri　2"],
  ["G2S10014_G2", "東１号館Ｅ１-３０６／E1-306", "金／Fri　2"],
  ["G2S10014_G3", "東１号館Ｅ１-２０１／E1-201", "金／Fri　2"],
  ["G2S10014_G4", "東１号館Ｅ１-２１０／E1-210", "金／Fri　4"],
  ["G2S10014_G5", "東１号館Ｅ１-２０９／E1-209", "金／Fri　4"],
  ["G2S10014_G6", "東１号館Ｅ１-３０６／E1-306", "金／Fri　4"],
  ["G2S10014_G7", "東１号館Ｅ１-２０１／E1-201", "金／Fri　4"],
  ["G2S10014_G8", "東１号館Ｅ１-２０８／E1-208", "金／Fri　4"],
  ["G2S10014_G9", "東１号館Ｅ１-２１０／E1-210", "金／Fri　2"],
  ["G2S10014_Ga", "東１号館Ｅ１-２０９／E1-209", "金／Fri　2"],
  ["G2S70022_G1", "東１号館Ｅ１-２０９／E1-209", "金／Fri　2"],
  ["G2S70022_G2", "東１号館Ｅ１-２０１／E1-201", "金／Fri　2"],
  ["G2S70022_G3", "東１号館Ｅ１-３０１／E1-301", "金／Fri　2"],
  ["G2S70022_G4", "東１号館Ｅ１-２０８／E1-208", "金／Fri　2"],
  ["G2S70022_G5", "東１号館Ｅ１-２１０／E1-210", "金／Fri　2"],
  ["G2S70022_G6", "東１号館Ｅ１-３０６／E1-306", "金／Fri　2"],
  ["G2S70022_G7", "東１号館Ｅ１-２０８／E1-208", "金／Fri　4"],
  ["G2S70022_G8", "東１号館Ｅ１-３０６／E1-306", "金／Fri　4"],
  ["G2S70022_G9", "東１号館Ｅ１-２０１／E1-201", "金／Fri　4"],
  ["G2S70022_Ga", "東１号館Ｅ１-２０９／E1-209", "金／Fri　4"],
  ["G2S70023_G1", "東１号館Ｅ１-３０１／E1-301", "水／Wed　4"],
  ["G2S70023_G2", "東１号館Ｅ１-２０１／E1-201", "水／Wed　4"],
  ["G2S70023_G3", "東１号館Ｅ１-２０６／E1-206", "水／Wed　4"],
  ["G2S70023_G4", "東１号館Ｅ１-３０５／E1-305", "水／Wed　4"],
  ["G2S70023_G5", "東１号館Ｅ１-３０４／E1-304", "水／Wed　4"],
  ["G2S70023_G7", "東１号館Ｅ１-２０１／E1-201", "木／Thu　2"],
  ["G2S70023_G8", "東１号館Ｅ１-２０８／E1-208", "木／Thu　2"],
  ["G2S70023_G9", "東１号館Ｅ１-２０９／E1-209", "木／Thu　2"],
  ["G2S70023_Ga", "東１号館Ｅ１-３０６／E1-306", "木／Thu　2"],
  ["G2S70024_G1", "東１号館Ｅ１-３０４／E1-304", "水／Wed　4"],
  ["G2S70024_G2", "東１号館Ｅ１-３０５／E1-305", "水／Wed　4"],
  ["G2S70024_G3", "東１号館Ｅ１-３０１／E1-301", "水／Wed　4"],
  ["G2S70024_G4", "東１号館Ｅ１-２０１／E1-201", "水／Wed　4"],
  ["G2S70024_G5", "東１号館Ｅ１-２０６／E1-206", "水／Wed　4"],
  ["G2S70024_G7", "東１号館Ｅ１-２０１／E1-201", "木／Thu　2"],
  ["G2S70024_G8", "東１号館Ｅ１-３０６／E1-306", "木／Thu　2"],
  ["G2S70024_G9", "東１号館Ｅ１-２０８／E1-208", "木／Thu　2"],
  ["G2S70024_Ga", "東１号館Ｅ１-２０９／E1-209", "木／Thu　2"],
  ["G3001001_G1", "陸上競技場／陸上競技場", "金／Fri　3"],
  ["G3001002_G1", "多目的広場／多目的広場", "金／Fri　3"],
  ["G3001003_G1", "テニスコート／テニスコート", "金／Fri　3"],
  ["G3001004_G1", "陸上競技場／陸上競技場", "金／Fri　2"],
  ["G3001005_G1", "体育館（武道場）／体育館（武道場）", "金／Fri　2"],
  ["G3001006_G1", "テニスコート／テニスコート", "金／Fri　2"],
  ["G3001007_G1", "体育館（武道場）／体育館（武道場）", "金／Fri　3"],
  ["G3001008_G1", "陸上競技場／陸上競技場", "金／Fri　2"],
  ["G3001009_G1", "体育館（卓球場）／体育館（卓球場）", "金／Fri　3"],
  ["G3001010_G1", "体育館（アリーナ）／体育館（アリーナ）", "金／Fri　2"],
  ["G3001011_G1", "体育館（アリーナ）／体育館（アリーナ）", "金／Fri　3"],
  ["G3001012_G1", "体育館（卓球場）／体育館（卓球場）", "金／Fri　2"],
  ["G3001013_G1", "", "金／Fri　3"],
  ["G3001014_G1", "", "金／Fri　2"],
  ["G3001015_G1", "体育館（アリーナ）／体育館（アリーナ）", "月／Mon　3"],
  ["G3001017_G1", "体育館（アリーナ）／体育館（アリーナ）", "月／Mon　2"],
  ["G3001022_G1", "体育館（武道場）／体育館（武道場）", "水／Wed　3"],
  ["G3001025_G1", "体育館（卓球場）／体育館（卓球場）", "月／Mon　2"],
  ["G3001028_G1", "体育館（武道場）／体育館（武道場）", "水／Wed　2"],
  ["G3001029_G1", "体育館（卓球場）／体育館（卓球場）", "月／Mon　3"],
  ["G3L80002_G1", "東１号館Ｅ１-１０１／E1-101", "金／Fri　4"],
  ["K1000001_K1", "東１号館Ｅ１-２０５／E1-205", "木／Thu　4"],
  ["K1000002_K1", "東１号館Ｅ１-２０５／E1-205", "木／Thu　4"],
  ["K1000003_K1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　2"],
  ["K1000004_K1", "東１号館Ｅ１-２０５／E1-205", "月／Mon　3"],
  ["K1000005_K1", "東１号館Ｅ１-２０５／E1-205", "月／Mon　4"],
  ["K1000006_K1", "学術情報センター第１演習室（西５号館）／学術情報センター第１演習室（西５号館）", "金／Fri　2"],
  ["K1000007_K1", "学術情報センター第１演習室（西５号館）／学術情報センター第１演習室（西５号館）", "金／Fri　2"],
  ["K1000008_K1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　2"],
  ["K1000009_K1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "火／Tue　3"],
  ["K1000010_K1", "東１号館Ｅ１-２０６／E1-206", "月／Mon　5"],
  ["K1000011_K1", "東１号館Ｅ１-２０６／E1-206", "月／Mon　5"],
  ["K1000012_K1", "東１号館Ｅ１-２０１／E1-201", "木／Thu　4"],
  ["K1000013_K1", "北１号館Ａ２０４／北１号館Ａ２０４", "木／Thu　5"],
  ["K1000014_K1", "", "他／Otr"],
  ["K1000015_K1", "学術情報センター第１演習室（西５号館）／学術情報センター第１演習室（西５号館）", "火／Tue　2"],
  ["K1000018_K1", "東１号館Ｅ１-２１０／E1-210", "木／Thu　2"],
  ["K1000019_K1", "東１号館Ｅ１-２０５／E1-205", "木／Thu　5"],
  ["K1000020_K1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　5"],
  ["K1000021_K1", "北１号館Ａ２０４／北１号館Ａ２０４", "木／Thu　4"],
  ["K1000024_K1", "", "他／Otr"],
  ["K1000025_K1", "東１号館Ｅ１-２０９／E1-209", "水／Wed　2"],
  ["K1K00001_K1", "北１号館Ａ１０４／北１号館Ａ１０４", "木／Thu　5"],
  ["K1K00002_K1", "東１号館Ｅ１-２０３／E1-203", "他／Otr"],
  ["K1K00003_K1", "", "他／Otr"],
  ["K1K00004_K1", "", "他／Otr"],
  ["K1K00004_K2", "", "他／Otr"],
  ["K1K00004_K3", "", "他／Otr"],
  ["K1K00004_K4", "", "他／Otr"],
  ["K1K00004_K5", "", "他／Otr"],
  ["K1K00004_K6", "", "他／Otr"],
  ["K1K00004_K7", "", "他／Otr"],
  ["K1K00004_K8", "", "他／Otr"],
  ["K1K00004_K9", "", "他／Otr"],
  ["K1K00004_Ka", "", "他／Otr"],
  ["K1K00004_Kb", "", "他／Otr"],
  ["K1K00004_Kc", "", "他／Otr"],
  ["K1K00005_K1", "", "他／Otr"],
  ["K1K00005_K2", "", "他／Otr"],
  ["K1K00005_K3", "", "他／Otr"],
  ["K1K00005_K4", "", "他／Otr"],
  ["K1K00005_K5", "", "他／Otr"],
  ["K1K00005_K6", "", "他／Otr"],
  ["K1K00005_K7", "", "他／Otr"],
  ["K1K00005_K8", "", "他／Otr"],
  ["K1K00005_K9", "", "他／Otr"],
  ["K1K00005_Ka", "", "他／Otr"],
  ["K1K00005_Kb", "", "他／Otr"],
  ["K1K00005_Kc", "", "他／Otr"],
  ["L1100362_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　3"],
  ["L1100363_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　3"],
  ["L1100366_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　5"],
  ["L1100367_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "木／Thu　1"],
  ["L1100368_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　3"],
  ["L1100369_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "火／Tue　3"],
  ["L1100374_L1", "東３号館南２０７／東３号館南２０７", "月／Mon　2"],
  ["L1100382_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "水／Wed　4"],
  ["L1100384_L1", "東３号館中４０８／東３号館中４０８", "月／Mon　3"],
  ["L1100385_L1", "東３号館中４０８／東３号館中４０８", "月／Mon　3"],
  ["L1100391_L1", "東３号館南４１０／東３号館南４１０", "木／Thu　2"],
  ["L1100392_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "木／Thu　1"],
  ["L1100393_L1", "東２号館Ｌ２０２／東２号館Ｌ２０２", "火／Tue　3"],
  ["L1100397_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "金／Fri　2"],
  ["L1100403_L1", "東２号館Ｌ２０２／東２号館Ｌ２０２", "水／Wed　4"],
  ["L1100409_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "月／Mon　2"],
  ["L1100423_L1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "火／Tue　3"],
  ["L1100431_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "火／Tue　2"],
  ["L1100434_L1", "東３号館中３０８／東３号館中３０８", "月／Mon　3,　月／Mon　4"],
  ["L1100435_L1", "東３号館中３０８／東３号館中３０８", "月／Mon　3,　月／Mon　4"],
  ["L1100439_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "火／Tue　1"],
  ["L1100446_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "木／Thu　2"],
  ["L1100447_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "金／Fri　1"],
  ["L1100448_L1", "東３号館北４１０／東３号館北４１０", "水／Wed　4,　水／Wed　5"],
  ["L1100478_L1", "東３号館中５０６／東３号館中５０６", "火／Tue　1"],
  ["L1100479_L1", "東５号館北１１４／東５号館北１１４", "火／Tue　1"],
  ["L1100485_L1", "東５号館南２０６／東５号館南２０６", "月／Mon　3"],
  ["L1100486_L1", "東５号館南２０６／東５号館南２０６", "月／Mon　3"],
  ["L1100492_L1", "東５号館南１０１／東５号館南１０１", "水／Wed　2"],
  ["L1100493_L1", "東５号館南１０１／東５号館南１０１", "木／Thu　3"],
  ["L1100499_L1", "東５号館南２０１／東５号館南２０１", "月／Mon　2"],
  ["L1100506_L1", "東５号館南１０６／東５号館南１０６", "水／Wed　4"],
  ["L1100513_L1", "", "他／Otr"],
  ["L1100529_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "金／Fri　1"],
  ["L1100530_L1", "東３号館南３０６／東３号館南３０６", "金／Fri　4"],
  ["L1100533_L1", "", "他／Otr"],
  ["L1100539_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "金／Fri　1"],
  ["L1100543_L1", "", "他／Otr"],
  ["L1100561_L1", "東３号館北２０４／東３号館北２０４", "月／Mon　1"],
  ["L1100563_L1", "東３号館北２０４／東３号館北２０４", "火／Tue　3,　火／Tue　4"],
  ["L1100564_L1", "東３号館北２０４／東３号館北２０４", "月／Mon　2"],
  ["L1100567_L1", "東３号館北２０６／東３号館北２０６", "水／Wed　1,　水／Wed　2"],
  ["L1100572_L1", "東３号館北２０４／東３号館北２０４", "火／Tue　2"],
  ["L1100573_L1", "東３号館北２０４／東３号館北２０４", "月／Mon　4"],
  ["L1100582_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　1"],
  ["L1100583_L1", "東３号館中４０８／東３号館中４０８", "金／Fri　2"],
  ["L1100584_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　5"],
  ["L1100596_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "火／Tue　1"],
  ["L1100599_L1", "その他／その他", "火／Tue　6"],
  ["L1100601_L1", "東２号館Ｌ１０１, 東５号館北１０１, 東５号館北２１２／東２号館Ｌ１０１, 東５号館北１０１, 東５号館北２１２", "金／Fri　1"],
  ["L1100603_L1", "東２号館Ｌ１０１, 体育関連施設／東２号館Ｌ１０１, 体育関連施設", "火／Tue　3"],
  ["L1100604_L1", "東２号館Ｌ２０１, 東３号館北２０４, 東３号館北２０６／東２号館Ｌ２０１, 東３号館北２０４, 東３号館北２０６", "水／Wed　4"],
  ["L1100608_L1", "東５号館南１０１, 東５号館南１０６／東５号館南１０１, 東５号館南１０６", "水／Wed　1"],
  ["L1100609_L1", "東５号館南１０１, 東５号館南１０６／東５号館南１０１, 東５号館南１０６", "月／Mon　1"],
  ["L1100688_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　1"],
  ["L1100689_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　1"],
  ["L1100717_L1", "", "他／Otr"],
  ["L1100718_L1", "未定／未定", "他／Otr"],
  ["L1100719_L1", "", "他／Otr"],
  ["L1100720_L1", "", "他／Otr"],
  ["L1100723_L1", "", "他／Otr"],
  ["L1100724_L1", "", "他／Otr"],
  ["L1100748_L1", "", "他／Otr"],
  ["L1100761_L1", "東３号館中４０８／東３号館中４０８", "金／Fri　1"],
  ["L1100770_L1", "東３号館中４０８／東３号館中４０８", "火／Tue　1"],
  ["L1100774_L1", "", "他／Otr"],
  ["L1100775_L1", "", "他／Otr"],
  ["L1100830_L1", "", "他／Otr"],
  ["L1100831_L1", "", "他／Otr"],
  ["L1100845_L1", "未定／未定", "他／Otr"],
  ["L1100846_L1", "その他／その他", "金／Fri　2"],
  ["L1100860_L1", "東３号館北５１１／東３号館北５１１", "水／Wed　4"],
  ["L1100863_L1", "東３号館北５１１／東３号館北５１１", "水／Wed　3"],
  ["L1100895_L1", "東３号館中４０６／東３号館中４０６", "月／Mon　2"],
  ["L1100938_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "水／Wed　3"],
  ["L1100945_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "金／Fri　2"],
  ["L1100962_L1", "", "他／Otr"],
  ["L1100979_L1", "", "他／Otr"],
  ["L1100982_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "金／Fri　1"],
  ["L1101002_L1", "東３号館北４１０／東３号館北４１０", "金／Fri　2"],
  ["L1101024_L1", "", "他／Otr"],
  ["L1101053_L1", "", "他／Otr"],
  ["L1101096_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　2"],
  ["L1101097_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　4"],
  ["L1101130_L1", "東５号館南２０１, 東５号館南２０６／東５号館南２０１, 東５号館南２０６", "月／Mon　2"],
  ["L1101175_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "月／Mon　2"],
  ["L1101194_L1", "", "他／Otr"],
  ["L1101271_L1", "東３号館北２０４／東３号館北２０４", "木／Thu　3"],
  ["L1101407_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "月／Mon　1"],
  ["L1101408_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　1"],
  ["L1101445_L1", "東２号館Ｌ１０１, 東２号館Ｌ２０１／東２号館Ｌ１０１, 東２号館Ｌ２０１", "金／Fri　4"],
  ["L1101446_L1", "東２号館Ｌ１０１, 東２号館Ｌ２０１／東２号館Ｌ１０１, 東２号館Ｌ２０１", "金／Fri　3"],
  ["L1101455_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "火／Tue　4"],
  ["L1101456_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "月／Mon　2"],
  ["L1101486_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "金／Fri　2"],
  ["L1101488_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "金／Fri　2"],
  ["L1101489_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "金／Fri　4"],
  ["L1101490_L1", "東５号館北１１４／東５号館北１１４", "金／Fri　5"],
  ["L1101491_L1", "東５号館南２０３／東５号館南２０３", "火／Tue　2"],
  ["L1101492_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "木／Thu　1"],
  ["L1101493_L1", "", "他／Otr"],
  ["L1101494_L1", "未定／未定", "他／Otr"],
  ["L1101495_L1", "東３号館北２０６／東３号館北２０６", "火／Tue　1"],
  ["L1101496_L1", "東３号館北２０４, 東３号館北２０６／東３号館北２０４, 東３号館北２０６", "月／Mon　3"],
  ["L1101497_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "月／Mon　4"],
  ["L1110227_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "木／Thu　2"],
  ["L1110234_L1", "東３号館中４０８／東３号館中４０８", "木／Thu　3"],
  ["L1110321_L1", "", "他／Otr"],
  ["L1110339_L1", "東３号館中４０６／東３号館中４０６", "木／Thu　2"],
  ["L1110372_L1", "東５号館南２０１／東５号館南２０１", "月／Mon　4"],
  ["L1110376_L1", "東５号館南２０３／東５号館南２０３", "火／Tue　4"],
  ["L1110382_L1", "", "他／Otr"],
  ["L1110383_L1", "", "他／Otr"],
  ["L1110396_L1", "", "他／Otr"],
  ["L1110526_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "火／Tue　5"],
  ["L1110527_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　4"],
  ["L1110530_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "月／Mon　2"],
  ["L1110531_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "火／Tue　3"],
  ["L1110532_L1", "東３号館中４０８／東３号館中４０８", "木／Thu　1"],
  ["L1110533_L1", "東５号館北１１４／東５号館北１１４", "金／Fri　5"],
  ["L1110534_L1", "", "他／Otr"],
  ["L1110535_L1", "", "他／Otr"],
  ["L1110536_L1", "東５号館南２０３／東５号館南２０３", "火／Tue　4"],
  ["L1110537_L1", "東２号館Ｌ１０５, 体育館（アリーナ）／東２号館Ｌ１０５, 体育館（アリーナ）", "水／Wed　1"],
  ["L1110538_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "木／Thu　2"],
  ["L1110540_L1", "東３号館北２０４／東３号館北２０４", "木／Thu　3"],
  ["L1110541_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "水／Wed　1"],
  ["L1110542_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "木／Thu　3"],
  ["L1110569_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　2"],
  ["L1110680_L1", "", "他／Otr"],
  ["L1130006_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "木／Thu　1"],
  ["L1130091_L1", "", "他／Otr"],
  ["L1130092_L1", "", "他／Otr"],
  ["L1130093_L1", "", "他／Otr"],
  ["L1130094_L1", "", "他／Otr"],
  ["L1130095_L1", "", "他／Otr"],
  ["L1150020_L1", "", "他／Otr"],
  ["L1150029_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　3"],
  ["L1150037_L1", "東３号館中４０８／東３号館中４０８", "月／Mon　2"],
  ["L1150038_L1", "東３号館中４０８／東３号館中４０８", "月／Mon　2"],
  ["L1160010_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "木／Thu　1"],
  ["L1160011_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "木／Thu　2"],
  ["L1160050_L1", "", "他／Otr"],
  ["L1160051_L1", "", "他／Otr"],
  ["L1160052_L1", "", "他／Otr"],
  ["L1160053_L1", "", "他／Otr"],
  ["L1160060_L1", "", "他／Otr"],
  ["L1160062_L1", "その他／その他", "木／Thu　3"],
  ["L1160088_L1", "", "他／Otr"],
  ["L1160089_L1", "", "他／Otr"],
  ["L1170013_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　1"],
  ["L1170014_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　1"],
  ["L1170017_L1", "", "他／Otr"],
  ["L1170018_L1", "", "他／Otr"],
  ["L1170021_L1", "", "他／Otr"],
  ["L1170022_L1", "", "他／Otr"],
  ["L1170026_L1", "東５号館北１１４／東５号館北１１４", "月／Mon　3"],
  ["L1170027_L1", "東５号館北１１４／東５号館北１１４", "月／Mon　2"],
  ["L1170046_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "火／Tue　2"],
  ["L1170051_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　1"],
  ["L1170052_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　1"],
  ["L1170053_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "月／Mon　3"],
  ["L1170054_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "月／Mon　3"],
  ["L1170166_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "月／Mon　2"],
  ["L1180002_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "金／Fri　1"],
  ["L1180003_L1", "", "他／Otr"],
  ["L1180012_L1", "", "他／Otr"],
  ["L1180023_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　2"],
  ["L1180024_L1", "東５号館北１０１／東５号館北１０１", "水／Wed　1"],
  ["L1180026_L1", "東５号館北１０１／東５号館北１０１", "木／Thu　3"],
  ["L1190102_L1", "", "他／Otr"],
  ["L1190103_L1", "", "他／Otr"],
  ["L1190106_L1", "東３号館中４０６／東３号館中４０６", "水／Wed　2"],
  ["L1190151_L1", "東４号館実１０１／東４号館実１０１", "月／Mon　4"],
  ["L1190152_L1", "東４号館実１０１／東４号館実１０１", "月／Mon　3"],
  ["L1190153_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "水／Wed　3"],
  ["L1190154_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "水／Wed　4"],
  ["L1190155_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "火／Tue　1"],
  ["L1190156_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "火／Tue　1"],
  ["L1190157_L1", "東４号館実１０１／東４号館実１０１", "月／Mon　4"],
  ["L1190158_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "水／Wed　4"],
  ["L1190159_L1", "", "他／Otr"],
  ["L1190164_L1", "", "他／Otr"],
  ["L1190169_L1", "", "他／Otr"],
  ["L1190170_L1", "", "他／Otr"],
  ["L1190171_L1", "", "他／Otr"],
  ["L1190178_L1", "東４号館実１０１／東４号館実１０１", "土／Sat　3,　土／Sat　4"],
  ["L1190179_L1", "東４号館実２０１, 東４号館実２０２／東４号館実２０１, 東４号館実２０２", "土／Sat　3,　土／Sat　4"],
  ["L1200002_L1", "", "他／Otr"],
  ["L1200004_L1", "東１号館Ｅ１-１０２／E1-102", "木／Thu　2"],
  ["L1200016_L1", "", "他／Otr"],
  ["L1200019_L1", "東５号館北１１４／東５号館北１１４", "水／Wed　2"],
  ["L1200020_L1", "東５号館南２０３／東５号館南２０３", "月／Mon　4"],
  ["L1200021_L1", "東５号館南２０３／東５号館南２０３", "金／Fri　4"],
  ["L1200022_L1", "東５号館南２０３／東５号館南２０３", "木／Thu　2"],
  ["L1200023_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "木／Thu　2"],
  ["L1200027_L1", "", "他／Otr"],
  ["L1200029_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　3"],
  ["L1200030_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　5"],
  ["L1200033_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "火／Tue　2"],
  ["L1200039_L1", "学術情報センター第４演習室（西５号館）／学術情報センター第４演習室（西５号館）", "月／Mon　2"],
  ["L1200054_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　2"],
  ["L1200056_L1", "", "他／Otr"],
  ["L1200092_L1", "東３号館中４０７／東３号館中４０７", "木／Thu　2"],
  ["L1200102_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "水／Wed　2"],
  ["L1200103_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "水／Wed　2"],
  ["L1200104_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "木／Thu　3"],
  ["L1200105_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "火／Tue　1"],
  ["L1210102_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "水／Wed　4"],
  ["L1210104_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "火／Tue　2"],
  ["L1210109_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　4"],
  ["L1210116_L1", "", "他／Otr"],
  ["L1210122_L1", "", "他／Otr"],
  ["L1210123_L1", "", "他／Otr"],
  ["L1210126_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　2"],
  ["L1210127_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "月／Mon　2"],
  ["L1220102_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "木／Thu　3"],
  ["L1220111_L1", "", "他／Otr"],
  ["L1220115_L1", "東３号館北２０６／東３号館北２０６", "金／Fri　1,　金／Fri　2"],
  ["L1220116_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "月／Mon　3"],
  ["L1220117_L1", "", "他／Otr"],
  ["L1220118_L1", "", "他／Otr"],
  ["L1220125_L1", "未定／未定", "木／Thu　4,　木／Thu　5"],
  ["L1230004_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "木／Thu　2"],
  ["L1230007_L1", "東５号館北１０１／東５号館北１０１", "水／Wed　2"],
  ["L1230014_L1", "東３号館北４１８／東３号館北４１８", "木／Thu　1,　木／Thu　2"],
  ["L1230015_L1", "東３号館北２０４／東３号館北２０４", "火／Tue　2"],
  ["L1230018_L1", "", "他／Otr"],
  ["L1230019_L1", "", "他／Otr"],
  ["L1230020_L1", "", "他／Otr"],
  ["L1230021_L1", "", "他／Otr"],
  ["L1230031_L1", "", "他／Otr"],
  ["L1230032_L1", "", "他／Otr"],
  ["L1230035_L1", "", "他／Otr"],
  ["L1230038_L1", "", "他／Otr"],
  ["L1240004_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　2"],
  ["L1240017_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "月／Mon　4"],
  ["L1240022_L1", "東５号館北１０１／東５号館北１０１", "水／Wed　4"],
  ["L1240023_L1", "東５号館北１０１／東５号館北１０１", "木／Thu　2"],
  ["L1250002_L1", "東３号館南４０２／東３号館南４０２", "金／Fri　2"],
  ["L1250005_L1", "東３号館北５１６／東３号館北５１６", "木／Thu　2"],
  ["L1250006_L1", "東３号館北５１６／東３号館北５１６", "火／Tue　2"],
  ["L1250014_L1", "東３号館北２０４／東３号館北２０４", "火／Tue　1"],
  ["L1250023_L1", "", "他／Otr"],
  ["L1250024_L1", "", "他／Otr"],
  ["L1250025_L1", "", "他／Otr"],
  ["L1250026_L1", "", "他／Otr"],
  ["L1260001_L1", "東５号館北１１４／東５号館北１１４", "金／Fri　2"],
  ["L1260005_L1", "東３号館北２０４／東３号館北２０４", "水／Wed　3"],
  ["L1270001_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "金／Fri　2"],
  ["L1270004_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "金／Fri　2"],
  ["L1270005_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "火／Tue　2"],
  ["L1270010_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "水／Wed　1"],
  ["L1270011_L1", "東５号館北１０１／東５号館北１０１", "火／Tue　3"],
  ["L1270012_L1", "東５号館南２０６／東５号館南２０６", "月／Mon　4"],
  ["L1270014_L1", "東５号館南２０１／東５号館南２０１", "月／Mon　3"],
  ["L1270015_L1", "東５号館南１０６／東５号館南１０６", "水／Wed　3"],
  ["L1270019_L1", "東５号館南２０３／東５号館南２０３", "月／Mon　2"],
  ["L1270020_L1", "東５号館南２０３／東５号館南２０３", "金／Fri　4"],
  ["L1270022_L1", "", "他／Otr"],
  ["L1270023_L1", "", "他／Otr"],
  ["L1270024_L1", "", "他／Otr"],
  ["L1270025_L1", "", "他／Otr"],
  ["L1270028_L1", "東５号館南２０３／東５号館南２０３", "金／Fri　5"],
  ["L1270029_L1", "東５号館南２０３／東５号館南２０３", "金／Fri　5"],
  ["L1270031_L1", "東５号館南２０３／東５号館南２０３", "火／Tue　2"],
  ["L1279999_L1", "", "他／Otr"],
  ["L1280000_L1", "その他, 東２号館Ｌ１０１／その他, 東２号館Ｌ１０１", "火／Tue　4"],
  ["L1280001_L1", "その他, 東２号館Ｌ１０１／その他, 東２号館Ｌ１０１", "火／Tue　4"],
  ["L1280005_L1", "東３号館北２０４, 東３号館北２０６／東３号館北２０４, 東３号館北２０６", "木／Thu　2"],
  ["L1280008_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "水／Wed　2"],
  ["L1280010_L1", "東５号館北１０４／東５号館北１０４", "火／Tue　2"],
  ["L1280014_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "木／Thu　4"],
  ["L1280016_L1", "東５号館南１０１／東５号館南１０１", "木／Thu　2"],
  ["L1280017_L1", "東３号館北２０４, 東３号館北２０６／東３号館北２０４, 東３号館北２０６", "水／Wed　1"],
  ["L1280018_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　4"],
  ["L1280019_L1", "東３号館北５１６／東３号館北５１６", "火／Tue　4"],
  ["L1280023_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "木／Thu　3"],
  ["L1280028_L1", "", "他／Otr"],
  ["L1280029_L1", "", "他／Otr"],
  ["L1280030_L1", "", "他／Otr"],
  ["L1280031_L1", "", "他／Otr"],
  ["L1280034_L1", "", "他／Otr"],
  ["L1280035_L1", "", "他／Otr"],
  ["L1280036_L1", "", "他／Otr"],
  ["L1280037_L1", "", "他／Otr"],
  ["L1280038_L1", "", "他／Otr"],
  ["L1280048_L1", "東３号館南４０５／東３号館南４０５", "金／Fri　3"],
  ["L1280049_L1", "東３号館中４０７／東３号館中４０７", "月／Mon　2"],
  ["L1280052_L1", "", "水／Wed　2,　他／Otr"],
  ["L1280053_L1", "附属農場／附属農場", "水／Wed　3,　水／Wed　4"],
  ["L1280054_L1", "附属農場／附属農場", "水／Wed　3,　水／Wed　4"],
  ["L1280055_L1", "", "他／Otr"],
  ["L1280060_L1", "", "他／Otr"],
  ["L1280061_L1", "", "他／Otr"],
  ["L1280062_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "木／Thu　1"],
  ["L1280063_L1", "", "他／Otr"],
  ["L1280065_L1", "", "他／Otr"],
  ["L1280066_L1", "", "他／Otr"],
  ["L1280067_L1", "", "他／Otr"],
  ["L1280070_L1", "東５号館北１０１／東５号館北１０１", "木／Thu　3"],
  ["L1280071_L1", "東５号館南１０１, 東５号館南１０６／東５号館南１０１, 東５号館南１０６", "月／Mon　3"],
  ["L1280072_L1", "東５号館南２０６／東５号館南２０６", "月／Mon　4"],
  ["L1280083_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "木／Thu　1"],
  ["L1280084_L1", "東３号館南２０３／東３号館南２０３", "水／Wed　4"],
  ["L1280085_L1", "東３号館南２０３／東３号館南２０３", "水／Wed　2"],
  ["L1280086_L1", "東３号館南２０３／東３号館南２０３", "木／Thu　3"],
  ["L1280097_L1", "東５号館北１０１／東５号館北１０１", "金／Fri　2"],
  ["L1280098_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "水／Wed　1"],
  ["L1290001_L1", "", "他／Otr"],
  ["L1290002_L1", "", "他／Otr"],
  ["L1290003_L1", "", "他／Otr"],
  ["L1290004_L1", "", "他／Otr"],
  ["L1290007_L1", "", "他／Otr"],
  ["L1290008_L1", "", "他／Otr"],
  ["L1290009_L1", "", "他／Otr"],
  ["L1290010_L1", "", "他／Otr"],
  ["L1290011_L1", "東３号館南４０２／東３号館南４０２", "木／Thu　2"],
  ["L1290012_L1", "東３号館中４０６／東３号館中４０６", "木／Thu　1"],
  ["L1290038_L1", "", "他／Otr"],
  ["L1290039_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "火／Tue　3"],
  ["L1290045_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "火／Tue　2"],
  ["L1290046_L1", "", "他／Otr"],
  ["L1290047_L1", "", "他／Otr"],
  ["L1290048_L1", "", "他／Otr"],
  ["L1290049_L1", "", "他／Otr"],
  ["L1290050_L1", "", "他／Otr"],
  ["L1290051_L1", "", "他／Otr"],
  ["L1290052_L1", "", "他／Otr"],
  ["L1290053_L1", "", "他／Otr"],
  ["L1290054_L1", "", "他／Otr"],
  ["L1290055_L1", "", "他／Otr"],
  ["L1290056_L1", "", "他／Otr"],
  ["L1290057_L1", "", "他／Otr"],
  ["L1290058_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "火／Tue　2"],
  ["L1290059_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "火／Tue　2"],
  ["L1290060_L1", "東２号館Ｌ１０２, 東２号館Ｌ１０３, 東２号館Ｌ１０４, 東２号館Ｌ２０１／東２号館Ｌ１０２, 東２号館Ｌ１０３, 東２号館Ｌ１０４, 東２号館Ｌ２０１", "火／Tue　4"],
  ["L1290061_L1", "東２号館Ｌ１０１, 東２号館Ｌ１０２, 東２号館Ｌ１０３, 東２号館Ｌ１０４／東２号館Ｌ１０１, 東２号館Ｌ１０２, 東２号館Ｌ１０３, 東２号館Ｌ１０４", "火／Tue　4"],
  ["L1290062_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "月／Mon　4"],
  ["L1290064_L1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　2"],
  ["L1290065_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "水／Wed　2"],
  ["L1290066_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "月／Mon　4"],
  ["L1290067_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "月／Mon　4"],
  ["L1290068_L1", "東２号館Ｌ１０１, 西４号館Ｔ１０１／東２号館Ｌ１０１, T101", "木／Thu　2"],
  ["L1290069_L1", "東２号館Ｌ１０１, 西４号館Ｔ１０１／東２号館Ｌ１０１, T101", "木／Thu　2"],
  ["L1290070_L1", "東２号館Ｌ２０１, 体育関連施設／東２号館Ｌ２０１, 体育関連施設", "火／Tue　3"],
  ["L1290071_L1", "東２号館Ｌ２０１, 陸上競技場, 体育館（アリーナ）, 体育館（卓球場）／東２号館Ｌ２０１, 陸上競技場, 体育館（アリーナ）, 体育館（卓球場）", "火／Tue　2"],
  ["L1290072_L1", "東２号館Ｌ１０１, 東２号館Ｌ１０２／東２号館Ｌ１０１, 東２号館Ｌ１０２", "月／Mon　4"],
  ["L1290073_L1", "東２号館Ｌ１０１, 東２号館Ｌ１０２, 東２号館Ｌ１０３／東２号館Ｌ１０１, 東２号館Ｌ１０２, 東２号館Ｌ１０３", "火／Tue　1"],
  ["L1290074_L1", "東３号館中３０６／東３号館中３０６", "月／Mon　3,　月／Mon　4"],
  ["L1290075_L1", "東３号館中３０８／東３号館中３０８", "月／Mon　3,　月／Mon　4"],
  ["L1290078_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "月／Mon　2"],
  ["L1290079_L1", "", "他／Otr"],
  ["L1290080_L1", "", "他／Otr"],
  ["L1290081_L1", "", "他／Otr"],
  ["L1290082_L1", "", "他／Otr"],
  ["L1290083_L1", "", "他／Otr"],
  ["L1290084_L1", "", "他／Otr"],
  ["L1290085_L1", "", "他／Otr"],
  ["L1290086_L1", "", "他／Otr"],
  ["L1290087_L1", "", "他／Otr"],
  ["L1290088_L1", "", "他／Otr"],
  ["L1290089_L1", "", "他／Otr"],
  ["L1290090_L1", "", "他／Otr"],
  ["L1290091_L1", "", "他／Otr"],
  ["L1290100_L1", "", "他／Otr"],
  ["L1290102_L1", "東３号館中４０６／東３号館中４０６", "木／Thu　1"],
  ["L1300001_L1", "その他／その他", "火／Tue　6"],
  ["L1300002_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "金／Fri　2"],
  ["L1300006_L1", "東３号館南３０２／東３号館南３０２", "金／Fri　1"],
  ["L1300007_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "水／Wed　4"],
  ["L1300011_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "水／Wed　4"],
  ["L1300012_L1", "東３号館南４０５／東３号館南４０５", "月／Mon　5"],
  ["L1300013_L1", "東３号館南４０５／東３号館南４０５", "月／Mon　5"],
  ["L1300014_L1", "", "他／Otr"],
  ["L1300015_L1", "", "他／Otr"],
  ["L1300017_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "火／Tue　3"],
  ["L1300019_L1", "東３号館中４０８／東３号館中４０８", "火／Tue　3"],
  ["L1300020_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "水／Wed　3"],
  ["L1300021_L1", "東３号館中４０６／東３号館中４０６", "月／Mon　4"],
  ["L1300024_L1", "東３号館中３０６／東３号館中３０６", "月／Mon　3,　月／Mon　4"],
  ["L1300025_L1", "東３号館北４１０／東３号館北４１０", "火／Tue　3,　火／Tue　4"],
  ["L1300026_L1", "体育館（アリーナ）／体育館（アリーナ）", "金／Fri　1"],
  ["L1300027_L1", "体育館（武道場）／体育館（武道場）", "月／Mon　4"],
  ["L1300028_L1", "体育館（アリーナ）／体育館（アリーナ）", "水／Wed　4"],
  ["L1300029_L1", "陸上競技場, 体育館（アリーナ）, プール／陸上競技場, 体育館（アリーナ）, プール", "月／Mon　3"],
  ["L1300031_L1", "東３号館南３０６／東３号館南３０６", "火／Tue　1"],
  ["L1300036_L1", "東３号館北２０４／東３号館北２０４", "月／Mon　4"],
  ["L1300037_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "金／Fri　2"],
  ["L1300038_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "木／Thu　1"],
  ["L1300039_L1", "その他／その他", "金／Fri　3"],
  ["L1300041_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "月／Mon　4"],
  ["L1300046_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　3"],
  ["L1300047_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "月／Mon　2"],
  ["L1300048_L1", "東５号館北１１４／東５号館北１１４", "水／Wed　2"],
  ["L1300049_L1", "", "他／Otr"],
  ["L1300050_L1", "", "他／Otr"],
  ["L1300051_L1", "", "他／Otr"],
  ["L1300052_L1", "東３号館北２０４／東３号館北２０４", "木／Thu　1"],
  ["L1300053_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "水／Wed　2"],
  ["L1300057_L1", "", "他／Otr"],
  ["L1300058_L1", "", "他／Otr"],
  ["L1300059_L1", "", "他／Otr"],
  ["L1300060_L1", "", "他／Otr"],
  ["L1300061_L1", "", "他／Otr"],
  ["L1300062_L1", "", "他／Otr"],
  ["L1300063_L1", "", "他／Otr"],
  ["L1300064_L1", "", "他／Otr"],
  ["L1300065_L1", "", "他／Otr"],
  ["L1300066_L1", "", "他／Otr"],
  ["L1300067_L1", "", "他／Otr"],
  ["L1300068_L1", "", "他／Otr"],
  ["L1300069_L1", "", "他／Otr"],
  ["L1300070_L1", "", "他／Otr"],
  ["L1300071_L1", "", "他／Otr"],
  ["L1300072_L1", "", "他／Otr"],
  ["L1310001_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "水／Wed　2"],
  ["L1310002_L1", "その他／その他", "水／Wed　4"],
  ["L1310003_L1", "東１号館Ｅ１-１０３／E1-103", "木／Thu　2"],
  ["L1310004_L1", "", "他／Otr"],
  ["L1310005_L1", "未定／未定", "他／Otr"],
  ["L1310006_L1", "東５号館南１０１, 東５号館南１０６／東５号館南１０１, 東５号館南１０６", "木／Thu　1"],
  ["L1310008_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "水／Wed　5"],
  ["L1310009_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "水／Wed　5"],
  ["L1310011_L1", "東２号館Ｌ２０３／東２号館Ｌ２０３", "木／Thu　2"],
  ["L1310012_L1", "", "他／Otr"],
  ["L1310016_L1", "東３号館中４０６／東３号館中４０６", "木／Thu　2"],
  ["L1310022_L1", "東５号館北１１４／東５号館北１１４", "木／Thu　2"],
  ["L1310023_L1", "東５号館南２０６／東５号館南２０６", "月／Mon　2"],
  ["L1310024_L1", "東５号館南１０１／東５号館南１０１", "水／Wed　4"],
  ["L1310025_L1", "東５号館南２０１／東５号館南２０１", "月／Mon　3"],
  ["L1310026_L1", "東５号館南１０６／東５号館南１０６", "火／Tue　2"],
  ["L1310027_L1", "", "他／Otr"],
  ["L1310028_L1", "", "他／Otr"],
  ["L1310030_L1", "", "他／Otr"],
  ["L1310031_L1", "", "他／Otr"],
  ["L1310032_L1", "", "他／Otr"],
  ["L1310033_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "水／Wed　4"],
  ["L1310034_L1", "東２号館Ｌ１０３／東２号館Ｌ１０３", "水／Wed　5"],
  ["L1310035_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "木／Thu　1"],
  ["L1310036_L1", "東１号館Ｅ１-１０１, 東２号館Ｌ２０１／E1-101, 東２号館Ｌ２０１", "金／Fri　1"],
  ["L1310037_L1", "その他／その他", "水／Wed　3"],
  ["L1310038_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "水／Wed　3"],
  ["L1310039_L1", "", "他／Otr"],
  ["L1310043_L1", "東２号館Ｌ１０１, 東２号館Ｌ１０３, 東２号館Ｌ２０１, 東２号館Ｌ２０２／東２号館Ｌ１０１, 東２号館Ｌ１０３, 東２号館Ｌ２０１, 東２号館Ｌ２０２", "金／Fri　2"],
  ["L1310045_L1", "東３号館中４０６／東３号館中４０６", "金／Fri　4"],
  ["L1310046_L1", "東３号館南４１０／東３号館南４１０", "火／Tue　5"],
  ["L1310047_L1", "東２号館Ｌ１０４, 東２号館Ｌ１０５／東２号館Ｌ１０４, 東２号館Ｌ１０５", "水／Wed　1"],
  ["L1310048_L1", "東２号館Ｌ２０２, 東２号館Ｌ２０３／東２号館Ｌ２０２, 東２号館Ｌ２０３", "水／Wed　1"],
  ["L1310050_L1", "", "他／Otr"],
  ["L1310053_L1", "", "他／Otr"],
  ["L1310054_L1", "", "他／Otr"],
  ["L1310056_L1", "東５号館南１０６／東５号館南１０６", "月／Mon　2"],
  ["L1310057_L1", "東５号館南１０１／東５号館南１０１", "水／Wed　4"],
  ["L1310059_L1", "その他, 東２号館Ｌ１０５／その他, 東２号館Ｌ１０５", "木／Thu　2"],
  ["L1310061_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "火／Tue　1"],
  ["L1310066_L1", "東５号館南１０１／東５号館南１０１", "木／Thu　3"],
  ["L1310067_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "木／Thu　2"],
  ["L1310068_L1", "東１号館Ｅ１-１０３, その他／E1-103, その他", "木／Thu　5"],
  ["L1310069_L1", "東２号館Ｌ１０２／東２号館Ｌ１０２", "水／Wed　4"],
  ["L1310070_L1", "", "他／Otr"],
  ["L1320002_L1", "東５号館南２０３／東５号館南２０３", "木／Thu　3"],
  ["L1320005_L1", "東３号館中４０６／東３号館中４０６", "水／Wed　2"],
  ["L1320006_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "月／Mon　3"],
  ["L1320007_L1", "", "他／Otr"],
  ["L1320009_L1", "東２号館Ｌ１０５／東２号館Ｌ１０５", "火／Tue　4"],
  ["L1320010_L1", "東３号館中４０８／東３号館中４０８", "火／Tue　2"],
  ["L1320011_L1", "東３号館中４０６／東３号館中４０６", "火／Tue　3"],
  ["L1320015_L1", "東３号館北２０６／東３号館北２０６", "金／Fri　2"],
  ["L1320018_L1", "東２号館Ｌ２０１, 東２号館Ｌ２０３／東２号館Ｌ２０１, 東２号館Ｌ２０３", "水／Wed　2"],
  ["L1320019_L1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　2"],
  ["L1320020_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "月／Mon　2"],
  ["L1320021_L1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "月／Mon　3"],
  ["L1320022_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "水／Wed　4"],
  ["L1320023_L1", "東２号館Ｌ１０１／東２号館Ｌ１０１", "金／Fri　4"],
  ["L1320024_L1", "", "他／Otr"],
  ["L1320026_L1", "", "他／Otr"],
  ["L1320032_L1", "", "他／Otr"],
  ["L1320033_L1", "", "他／Otr"],
  ["L1320034_L1", "", "他／Otr"],
  ["L1320035_L1", "", "他／Otr"],
  ["L1320036_L1", "", "他／Otr"],
  ["L1331000_L1", "", "他／Otr"],
  ["L1331001_L1", "", "他／Otr"],
  ["L1331002_L1", "", "他／Otr"],
  ["L1331003_L1", "", "他／Otr"],
  ["L1331004_L1", "", "他／Otr"],
  ["L1331010_L1", "東２号館Ｌ１０４／東２号館Ｌ１０４", "木／Thu　4"],
  ["L2318012_L2", "", "他／Otr"],
  ["L2318013_L2", "", "他／Otr"],
  ["L2318014_L2", "", "他／Otr"],
  ["L2318015_L2", "", "他／Otr"],
  ["L2416006_L2", "", "水／Wed　1,　水／Wed　2"],
  ["L2416007_L2", "", "水／Wed　1,　水／Wed　2"],
  ["L2416008_L2", "", "他／Otr"],
  ["L2416014_L2", "", "水／Wed　1,　水／Wed　2"],
  ["L2416015_L2", "", "他／Otr"],
  ["L2416017_L2", "", "金／Fri　1,　金／Fri　2"],
  ["L2416018_L2", "", "木／Thu　3,　木／Thu　4"],
  ["L2416019_L2", "", "水／Wed　1,　水／Wed　2"],
  ["L2416020_L2", "", "金／Fri　1,　金／Fri　2"],
  ["L2416022_L2", "", "金／Fri　1,　金／Fri　2"],
  ["L2416023_L2", "", "金／Fri　3,　金／Fri　4"],
  ["L2416024_L2", "", "他／Otr"],
  ["L2416025_L2", "", "他／Otr"],
  ["L2416026_L2", "", "他／Otr"],
  ["L2416027_L2", "", "木／Thu　1,　木／Thu　2"],
  ["L2416028_L2", "", "他／Otr"],
  ["L2416029_L2", "", "木／Thu　3,　木／Thu　4"],
  ["L2416030_L2", "", "金／Fri　3,　金／Fri　4"],
  ["L2416031_L2", "", "金／Fri　3,　金／Fri　4"],
  ["L2416033_L2", "", "他／Otr"],
  ["L2416034_L2", "", "他／Otr"],
  ["L2416035_L2", "", "他／Otr"],
  ["L2416036_L2", "", "他／Otr"],
  ["L2416037_L2", "", "他／Otr"],
  ["L2416038_L2", "", "他／Otr"],
  ["L2416039_L2", "", "他／Otr"],
  ["L2416040_L2", "", "他／Otr"],
  ["L2416041_L2", "", "他／Otr"],
  ["L2416042_L2", "", "他／Otr"],
  ["L2419003_L2", "", "他／Otr"],
  ["L2419004_L2", "", "他／Otr"],
  ["L2419005_L2", "", "他／Otr"],
  ["L2419006_L2", "", "他／Otr"],
  ["L2419007_L2", "", "他／Otr"],
  ["L2419008_L2", "", "木／Thu　3,　木／Thu　4"],
  ["L2419009_L2", "", "他／Otr"],
  ["L2419010_L2", "", "他／Otr"],
  ["L2419011_L2", "", "他／Otr"],
  ["L2419017_L2", "", "他／Otr"],
  ["L2419018_L2", "", "他／Otr"],
  ["L2419019_L2", "", "他／Otr"],
  ["L2419020_L2", "", "他／Otr"],
  ["L2419021_L2", "", "他／Otr"],
  ["L2419022_L2", "", "他／Otr"],
  ["L2419023_L2", "", "他／Otr"],
  ["L2419024_L2", "", "他／Otr"],
  ["L2419025_L2", "", "他／Otr"],
  ["L2419026_L2", "", "他／Otr"],
  ["L2419027_L2", "", "他／Otr"],
  ["L2419028_L2", "", "他／Otr"],
  ["L2419029_L2", "", "他／Otr"],
  ["L2419030_L2", "", "他／Otr"],
  ["L2419031_L2", "", "他／Otr"],
  ["L2419032_L2", "", "他／Otr"],
  ["L2419033_L2", "", "他／Otr"],
  ["L2419034_L2", "", "他／Otr"],
  ["L2419035_L2", "", "他／Otr"],
  ["L2420001_L2", "", "他／Otr"],
  ["L2420002_L2", "", "他／Otr"],
  ["L2420003_L2", "", "他／Otr"],
  ["L2420005_L2", "", "他／Otr"],
  ["L2420006_L2", "", "他／Otr"],
  ["L2420007_L2", "", "他／Otr"],
  ["L2420008_L2", "", "他／Otr"],
  ["L2420009_L2", "", "他／Otr"],
  ["L2420010_L2", "", "他／Otr"],
  ["L2420011_L2", "", "他／Otr"],
  ["L2420013_L2", "", "他／Otr"],
  ["L2420015_L2", "", "他／Otr"],
  ["L2433001_L2", "", "金／Fri　3,　金／Fri　4"],
  ["L2433002_L2", "", "金／Fri　3,　金／Fri　4"],
  ["L2433005_L2", "", "木／Thu　1,　木／Thu　2"],
  ["L2433007_L2", "", "他／Otr"],
  ["L2433008_L2", "", "他／Otr"],
  ["R1001001_G1", "東１号館Ｅ１-２０５／E1-205", "他／Otr"],
  ["R1001006_G1", "", "他／Otr"],
  ["R1001018_G1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　5"],
  ["R1001019_G1", "", "他／Otr"],
  ["R1001021_G1", "", "他／Otr"],
  ["R1001022_G1", "東１号館Ｅ１-２０８／E1-208", "金／Fri　5"],
  ["R1001024_G1", "東１号館Ｅ１-２０８／E1-208", "月／Mon　5"],
  ["R1001025_G1", "東１号館Ｅ１-２０８／E1-208", "月／Mon　5"],
  ["R1001032_G1", "東１号館Ｅ１-３０１／E1-301", "火／Tue　4"],
  ["R1001033_G1", "東１号館Ｅ１-３０１／E1-301", "火／Tue　4"],
  ["R1001035_G1", "東１号館Ｅ１-２０６／E1-206", "火／Tue　3"],
  ["R1001036_G1", "東１号館Ｅ１-２０５／E1-205", "他／Otr"],
  ["R1001037_G1", "東１号館Ｅ１-２０１／E1-201", "木／Thu　3"],
  ["R1001038_G1", "", "他／Otr"],
  ["R1001039_G1", "", "木／Thu　1"],
  ["R1001040_G1", "", "他／Otr"],
  ["R1001041_G1", "", "他／Otr"],
  ["R1001042_G1", "", "木／Thu　3,　木／Thu　4"],
  ["R1001042_G2", "", "他／Otr"],
  ["R1001043_G1", "", "他／Otr"],
  ["R1001061_G1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "火／Tue　1,　火／Tue　2"],
  ["R1001062_G1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "他／Otr"],
  ["R1001063_G1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　5"],
  ["R1001064_G1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　5"],
  ["R1001084_G1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　3"],
  ["R1001085_G1", "東１号館Ｅ１-１０２／E1-102", "木／Thu　1"],
  ["R1001086_G1", "東１号館Ｅ１-２０８／E1-208", "月／Mon　6"],
  ["R1001087_G1", "東１号館Ｅ１-２０８／E1-208", "金／Fri　6"],
  ["R1001097_G1", "東１号館Ｅ１-１０２／E1-102", "木／Thu　1"],
  ["R1001098_G1", "東１号館Ｅ１-２０５／E1-205", "金／Fri　2"],
  ["R1001099_G1", "東１号館Ｅ１-２１０／E1-210", "水／Wed　1"],
  ["R1001100_G1", "東１号館Ｅ１-２０８／E1-208", "水／Wed　4"],
  ["R1001102_G1", "東１号館Ｅ１-２１０／E1-210", "水／Wed　4"],
  ["R1001103_G1", "東１号館Ｅ１-２０５／E1-205", "金／Fri　4"],
  ["R1001104_G1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　3"],
  ["R1001109_G1", "南紀熊野サテライト／南紀熊野サテライト", "他／Otr"],
  ["R1001116_G1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　5"],
  ["R1001117_G1", "東１号館Ｅ１-２０６／E1-206", "金／Fri　4"],
  ["R1001120_G1", "南紀熊野サテライト／南紀熊野サテライト", "他／Otr"],
  ["R1001121_G1", "南紀熊野サテライト／南紀熊野サテライト", "他／Otr"],
  ["R1001122_G1", "南紀熊野サテライト／南紀熊野サテライト", "他／Otr"],
  ["R1001123_G1", "南紀熊野サテライト／南紀熊野サテライト", "他／Otr"],
  ["R1001124_G1", "南紀熊野サテライト／南紀熊野サテライト", "他／Otr"],
  ["R1001125_G1", "岸和田サテライト／岸和田サテライト", "他／Otr"],
  ["R1001126_G1", "岸和田サテライト／岸和田サテライト", "他／Otr"],
  ["R1001127_G1", "岸和田サテライト／岸和田サテライト", "他／Otr"],
  ["R1001128_G1", "岸和田サテライト／岸和田サテライト", "他／Otr"],
  ["R1001129_G1", "岸和田サテライト／岸和田サテライト", "他／Otr"],
  ["R1001130_G1", "東１号館Ｅ１-２０９／E1-209", "水／Wed　4"],
  ["R1001131_G1", "", "他／Otr"],
  ["R1001132_G1", "東１号館Ｅ１-２０６／E1-206", "火／Tue　2"],
  ["S1300100_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　1"],
  ["S1300100_S2", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　1"],
  ["S1300100_S3", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　2"],
  ["S1300270_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　3"],
  ["S1300270_S2", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　3"],
  ["S1300270_S3", "北１号館Ａ１０３／北１号館Ａ１０３", "金／Fri　3"],
  ["S1300270_S4", "北１号館Ａ１０３／北１号館Ａ１０３", "金／Fri　2"],
  ["S1300280_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　3"],
  ["S1300280_S2", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　3"],
  ["S1300280_S3", "北１号館Ａ１０３／北１号館Ａ１０３", "金／Fri　3"],
  ["S1300290_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "火／Tue　3"],
  ["S1300290_S2", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　3"],
  ["S1300290_S3", "北１号館Ａ１０４／北１号館Ａ１０４", "金／Fri　3"],
  ["S1300290_S4", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　4"],
  ["S1300300_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　3"],
  ["S1300300_S2", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　3"],
  ["S1300300_S3", "北１号館Ａ１０４／北１号館Ａ１０４", "金／Fri　3"],
  ["S1300360_S1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　2"],
  ["S1300370_S1", "東１号館Ｅ１-１０１／E1-101", "水／Wed　1"],
  ["S1300380_S1", "", "水／Wed　3"],
  ["S1300390_S1", "東１号館Ｅ１-１０１／E1-101", "火／Tue　5"],
  ["S1300400_S1", "", "金／Fri　1"],
  ["S1300410_S1", "", "金／Fri　1"],
  ["S1300420_S1", "", "金／Fri　5"],
  ["S1300430_S1", "", "金／Fri　5"],
  ["S1300440_S1", "", "木／Thu　1"],
  ["S1300450_S1", "", "木／Thu　1"],
  ["S1300460_S1", "", "月／Mon　1"],
  ["S1300470_S1", "", "月／Mon　1"],
  ["S1300480_S1", "", "月／Mon　5"],
  ["S1300490_S1", "", "月／Mon　5"],
  ["S1300500_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "月／Mon　3"],
  ["S1300501_S1", "北３号館Ｂ２０３／北３号館Ｂ２０３", "金／Fri　4"],
  ["S1300510_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "木／Thu　3,　木／Thu　4"],
  ["S1300520_S1", "北１号館Ａ６０１, 北１号館Ａ７０２／北１号館Ａ６０１, 北１号館Ａ７０２", "火／Tue　3,　火／Tue　4"],
  ["S1300530_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "月／Mon　3"],
  ["S1300531_S1", "北３号館Ｂ２０３／北３号館Ｂ２０３", "金／Fri　4"],
  ["S1300540_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "木／Thu　3,　木／Thu　4"],
  ["S1300550_S1", "北１号館Ａ６０１, 北１号館Ａ７０２／北１号館Ａ６０１, 北１号館Ａ７０２", "火／Tue　3,　火／Tue　4"],
  ["S1300560_S1", "北１号館Ａ３０１／北１号館Ａ３０１", "火／Tue　3"],
  ["S1300561_S1", "北３号館Ｂ２０３／北３号館Ｂ２０３", "月／Mon　2"],
  ["S1300570_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "金／Fri　1,　金／Fri　2"],
  ["S1300580_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "水／Wed　1,　水／Wed　2"],
  ["S1300590_S1", "北１号館Ａ３０１／北１号館Ａ３０１", "火／Tue　3"],
  ["S1300591_S1", "北３号館Ｂ２０３／北３号館Ｂ２０３", "月／Mon　2"],
  ["S1300600_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "水／Wed　1,　水／Wed　2"],
  ["S1300610_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "水／Wed　1,　水／Wed　2"],
  ["S1400050_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "月／Mon　1,　月／Mon　2"],
  ["S1400060_S1", "北３号館Ｂ２０２, 学術情報センター第３演習室（西５号館）／北３号館Ｂ２０２, 学術情報センター第３演習室（西５号館）", "金／Fri　3,　金／Fri　4"],
  ["S1400180_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　1"],
  ["S1400250_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "火／Tue　1"],
  ["S1400300_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "火／Tue　3,　火／Tue　4"],
  ["S1400430_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "水／Wed　3,　水／Wed　4"],
  ["S1400580_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　1"],
  ["S1400590_S1", "", "月／Mon　1,　月／Mon　2"],
  ["S1400650_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　3,　木／Thu　4"],
  ["S1400660_S1", "北１号館Ａ２０３, 北３号館Ｂ２０８／北１号館Ａ２０３, 北３号館Ｂ２０８", "火／Tue　3,　火／Tue　4"],
  ["S1400670_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "火／Tue　3,　火／Tue　4"],
  ["S1400680_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "月／Mon　1,　木／Thu　1"],
  ["S1400910_S1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　2"],
  ["S1401020_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "火／Tue　1,　火／Tue　2"],
  ["S1401060_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "火／Tue　4"],
  ["S1401120_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　3,　木／Thu　4"],
  ["S1401360_S1", "", "他／Otr"],
  ["S1401370_S1", "北１号館Ａ２０２, 北１号館Ａ２０３／北１号館Ａ２０２, 北１号館Ａ２０３", "月／Mon　1"],
  ["S1401410_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　3"],
  ["S1401430_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "金／Fri　1,　金／Fri　2"],
  ["S1401440_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "金／Fri　1,　金／Fri　2"],
  ["S1401470_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "火／Tue　1,　水／Wed　2"],
  ["S1401480_S1", "北３号館Ｂ２０３／北３号館Ｂ２０３", "火／Tue　3,　水／Wed　1"],
  ["S1401570_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "水／Wed　3,　水／Wed　4"],
  ["S1401580_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "木／Thu　4"],
  ["S1401870_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "水／Wed　1,　金／Fri　1"],
  ["S1401980_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　4,　月／Mon　5"],
  ["S1402020_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "月／Mon　3,　月／Mon　4"],
  ["S1402080_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "水／Wed　1,　水／Wed　2"],
  ["S1402320_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　5"],
  ["S1402530_S1", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　2,　金／Fri　3"],
  ["S1402580_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "金／Fri　3"],
  ["S1403290_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　3"],
  ["S1403490_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "火／Tue　2"],
  ["S1403640_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "木／Thu　2"],
  ["S1403650_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "木／Thu　3,　木／Thu　4"],
  ["S1403770_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "金／Fri　1,　金／Fri　2"],
  ["S1405000_S1", "東１号館Ｅ１-１０１／E1-101", "木／Thu　5"],
  ["S1405040_S1", "", "他／Otr"],
  ["S1405050_S1", "", "他／Otr"],
  ["S1405150_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "水／Wed　1,　金／Fri　1"],
  ["S1405160_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　5"],
  ["S1405190_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　4"],
  ["S1405240_S1", "北１号館Ａ２０３, 学術情報センター第３演習室（西５号館）／北１号館Ａ２０３, 学術情報センター第３演習室（西５号館）", "金／Fri　1,　金／Fri　2"],
  ["S1405250_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "木／Thu　3,　木／Thu　4"],
  ["S1405270_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "火／Tue　4,　火／Tue　5"],
  ["S1405290_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "水／Wed　3,　水／Wed　4"],
  ["S1405350_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "水／Wed　1,　水／Wed　2"],
  ["S1405390_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "金／Fri　1,　金／Fri　2"],
  ["S1405420_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "木／Thu　1"],
  ["S1405440_S1", "", "他／Otr"],
  ["S1405570_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "月／Mon　3"],
  ["S1405580_S1", "", "他／Otr"],
  ["S1405620_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "金／Fri　3,　金／Fri　4"],
  ["S1405740_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "水／Wed　4"],
  ["S1405850_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　1"],
  ["S1405860_S1", "北１号館Ａ７０２／北１号館Ａ７０２", "月／Mon　3,　月／Mon　4"],
  ["S1405890_S1", "", "月／Mon　3"],
  ["S1405920_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　5,　金／Fri　2"],
  ["S1405950_S1", "", "他／Otr"],
  ["S1405950_S2", "", "他／Otr"],
  ["S1405970_S1", "", "月／Mon　2"],
  ["S1406170_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　1,　水／Wed　2"],
  ["S1406190_S1", "", "他／Otr"],
  ["S1406210_S1", "", "他／Otr"],
  ["S1406250_S1", "北３号館Ｂ２０６／北３号館Ｂ２０６", "木／Thu　3,　木／Thu　4"],
  ["S1406280_S1", "", "他／Otr"],
  ["S1406370_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　2"],
  ["S1406400_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　3"],
  ["S1406410_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　3"],
  ["S1406420_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　3"],
  ["S1406430_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　2"],
  ["S1406480_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "月／Mon　1"],
  ["S1406490_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "月／Mon　1"],
  ["S1406570_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "火／Tue　5"],
  ["S1406590_S1", "", "水／Wed　6"],
  ["S1406730_S1", "", "他／Otr"],
  ["S1406740_S1", "", "他／Otr"],
  ["S1406750_S1", "北１号館Ａ１０４／北１号館Ａ１０４", "水／Wed　2"],
  ["S1406760_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "火／Tue　4"],
  ["S1406790_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "月／Mon　4"],
  ["S1406830_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　3"],
  ["S1406840_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　3"],
  ["S1406860_S1", "北１号館Ａ８０２, 北１号館Ａ８０３／北１号館Ａ８０２, 北１号館Ａ８０３", "月／Mon　3,　月／Mon　4"],
  ["S1406870_S1", "北１号館Ａ２０４／北１号館Ａ２０４", "水／Wed　2"],
  ["S1406960_S1", "北１号館Ａ３０３／北１号館Ａ３０３", "他／Otr"],
  ["S1406980_S1", "北３号館Ｂ２０３, 北３号館Ｂ２０６／北３号館Ｂ２０３, 北３号館Ｂ２０６", "月／Mon　3,　月／Mon　4"],
  ["S1406990_S1", "北３号館Ｂ２０３, 北３号館Ｂ２０６／北３号館Ｂ２０３, 北３号館Ｂ２０６", "木／Thu　3,　木／Thu　4"],
  ["S1407000_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　3"],
  ["S1407010_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　3"],
  ["S1407040_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　2"],
  ["S1407050_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　2"],
  ["S1407080_S1", "", "月／Mon　3"],
  ["S1407090_S1", "", "月／Mon　3"],
  ["S1407100_S1", "", "他／Otr"],
  ["S1407120_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　2"],
  ["S1407130_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "月／Mon　5"],
  ["S1407150_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "火／Tue　3,　火／Tue　4"],
  ["S1407170_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　2"],
  ["S1407180_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　3"],
  ["S1407200_S1", "", "水／Wed　6"],
  ["S1407210_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　2"],
  ["S1407220_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　2"],
  ["S1407250_S1", "北１号館Ａ１０３, 北１号館Ａ８０２, 北１号館Ａ８０３／北１号館Ａ１０３, 北１号館Ａ８０２, 北１号館Ａ８０３", "火／Tue　2"],
  ["S1407260_S1", "北１号館Ａ１０３, 北１号館Ａ８０２, 北１号館Ａ８０３／北１号館Ａ１０３, 北１号館Ａ８０２, 北１号館Ａ８０３", "火／Tue　2"],
  ["S1407350_S1", "北３号館Ｂ１０６／北３号館Ｂ１０６", "他／Otr"],
  ["S1407360_S1", "北３号館Ｂ１０６／北３号館Ｂ１０６", "他／Otr"],
  ["S1407370_S1", "北３号館Ｂ２０６／北３号館Ｂ２０６", "木／Thu　3,　木／Thu　4"],
  ["S1407400_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　1,　木／Thu　2"],
  ["S1407410_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　1,　木／Thu　2"],
  ["S1407440_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "木／Thu　4"],
  ["S1407450_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "木／Thu　4"],
  ["S1407460_S1", "北１号館Ａ８０２／北１号館Ａ８０２", "木／Thu　3"],
  ["S1407490_S1", "北３号館Ｂ２０８／北３号館Ｂ２０８", "月／Mon　3,　月／Mon　4"],
  ["S1407500_S1", "北３号館Ｂ２０８／北３号館Ｂ２０８", "月／Mon　3,　月／Mon　4"],
  ["S1407530_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "月／Mon　3,　月／Mon　4"],
  ["S1407540_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "月／Mon　3,　月／Mon　4"],
  ["S1407550_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "水／Wed　3,　水／Wed　4"],
  ["S1407560_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "水／Wed　3,　水／Wed　4"],
  ["S1407610_S1", "北１号館Ａ１０１, 北１号館Ａ１０３／北１号館Ａ１０１, 北１号館Ａ１０３", "水／Wed　2"],
  ["S1407620_S1", "北１号館Ａ１０１, 北１号館Ａ１０３／北１号館Ａ１０１, 北１号館Ａ１０３", "水／Wed　2"],
  ["S1407670_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "他／Otr"],
  ["S1407700_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "木／Thu　1,　木／Thu　2"],
  ["S1407730_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "木／Thu　4,　木／Thu　5"],
  ["S1407780_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　4"],
  ["S1407790_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　2"],
  ["S1407820_S1", "", "月／Mon　1"],
  ["S1407860_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　3"],
  ["S1407870_S1", "北３号館Ｂ２０２／北３号館Ｂ２０２", "月／Mon　3"],
  ["S1407880_S1", "", "他／Otr"],
  ["S1407890_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "水／Wed　1,　水／Wed　2"],
  ["S1407900_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　3,　火／Tue　4"],
  ["S1407910_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "水／Wed　3,　水／Wed　4"],
  ["S1407920_S1", "", "他／Otr"],
  ["S1407930_S1", "北１号館Ａ３０３／北１号館Ａ３０３", "金／Fri　4,　金／Fri　5"],
  ["S1407940_S1", "", "他／Otr"],
  ["S1407950_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　3"],
  ["S1407960_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　1"],
  ["S1407970_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　1"],
  ["S1407980_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "金／Fri　3"],
  ["S1407990_S1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "金／Fri　3"],
  ["S1408000_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　3"],
  ["S1408010_S1", "北３号館Ｂ１０６／北３号館Ｂ１０６", "火／Tue　4,　火／Tue　5"],
  ["S1408020_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "金／Fri　2"],
  ["S1408030_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "金／Fri　2"],
  ["S1408040_S1", "北３号館Ｂ１０６／北３号館Ｂ１０６", "金／Fri　3,　金／Fri　4"],
  ["S1408050_S1", "北３号館Ｂ１０６／北３号館Ｂ１０６", "金／Fri　3,　金／Fri　4"],
  ["S1408060_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "月／Mon　5"],
  ["S1408070_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "木／Thu　2"],
  ["S1408080_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "木／Thu　2"],
  ["S1408090_S1", "", "他／Otr"],
  ["S1408100_S1", "", "他／Otr"],
  ["S1408110_S1", "", "他／Otr"],
  ["S1408120_S1", "", "他／Otr"],
  ["S1408130_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "他／Otr"],
  ["S1408140_S1", "", "他／Otr"],
  ["S1408150_S1", "", "他／Otr"],
  ["S1408160_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "金／Fri　3,　金／Fri　4,　金／Fri　5"],
  ["S1408170_S1", "北３号館Ｂ５０１／北３号館Ｂ５０１", "火／Tue　4,　火／Tue　5"],
  ["S1408180_S1", "北３号館Ｂ５０２／北３号館Ｂ５０２", "金／Fri　1,　金／Fri　2,　他／Otr"],
  ["S1408230_S1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　1"],
  ["S1408240_S1", "東１号館Ｅ１-２０５／E1-205", "月／Mon　1"],
  ["S1408250_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　4"],
  ["S1408260_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "月／Mon　2"],
  ["S1408270_S1", "北１号館Ａ８０３／北１号館Ａ８０３", "火／Tue　3,　火／Tue　4"],
  ["S1408280_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "金／Fri　2"],
  ["S1408290_S1", "北１号館Ａ６０１, 北１号館Ａ６０２／北１号館Ａ６０１, 北１号館Ａ６０２", "月／Mon　5,　金／Fri　5"],
  ["S1408300_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "水／Wed　3"],
  ["S1408310_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "火／Tue　1,　火／Tue　2"],
  ["S1408320_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　1"],
  ["S1408330_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　1"],
  ["S1408340_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　3"],
  ["S1408350_S1", "北１号館Ａ６０１, 北１号館Ａ６０２, 北１号館Ａ８０３／北１号館Ａ６０１, 北１号館Ａ６０２, 北１号館Ａ８０３", "水／Wed　3,　水／Wed　4"],
  ["S1408360_S1", "北１号館Ａ８０３／北１号館Ａ８０３", "木／Thu　1,　木／Thu　2"],
  ["S1408390_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "月／Mon　5,　水／Wed　5"],
  ["S1408400_S1", "北１号館Ａ６０１, 北１号館Ａ６０２／北１号館Ａ６０１, 北１号館Ａ６０２", "木／Thu　4"],
  ["S1408410_S1", "北１号館Ａ６０１, 北１号館Ａ６０２／北１号館Ａ６０１, 北１号館Ａ６０２", "木／Thu　4"],
  ["S1408420_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "木／Thu　3"],
  ["S1408430_S1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "木／Thu　3"],
  ["S1408440_S1", "", "他／Otr"],
  ["S1408450_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "金／Fri　4"],
  ["S1408460_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "月／Mon　3,　月／Mon　4"],
  ["S1408470_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "月／Mon　3,　月／Mon　4"],
  ["S1408480_S1", "北１号館Ａ２０２, 学術情報センター第３演習室（西５号館）／北１号館Ａ２０２, 学術情報センター第３演習室（西５号館）", "月／Mon　3"],
  ["S1408490_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "金／Fri　3"],
  ["S1408500_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "金／Fri　3"],
  ["S1408510_S1", "北１号館Ａ６０１／北１号館Ａ６０１", "金／Fri　1,　金／Fri　2"],
  ["S1408520_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "木／Thu　3"],
  ["S1408530_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "火／Tue　4,　火／Tue　5"],
  ["S1408540_S1", "北１号館Ａ１０１／北１号館Ａ１０１", "水／Wed　4"],
  ["S1408550_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　2"],
  ["S1408560_S1", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　2"],
  ["S1600010_Sg", "", "他／Otr"],
  ["S1600010_Sh", "", "他／Otr"],
  ["S1600010_Si", "", "他／Otr"],
  ["S1600010_Sj", "", "他／Otr"],
  ["S1600010_Sk", "", "他／Otr"],
  ["S1600010_Sl", "", "他／Otr"],
  ["S1600010_Sm", "", "他／Otr"],
  ["S1600010_Sn", "", "他／Otr"],
  ["S1600010_So", "", "他／Otr"],
  ["S1600010_Sp", "", "他／Otr"],
  ["S1700120_S1", "北１号館Ａ１０３／北１号館Ａ１０３", "火／Tue　5"],
  ["S1700130_S1", "北１号館Ａ２０３／北１号館Ａ２０３", "金／Fri　3"],
  ["S21A0030_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "月／Mon　3,　水／Wed　3"],
  ["S21F0020_S6", "", "他／Otr"],
  ["S21G0090_SJ", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　1"],
  ["S21G0090_SK", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　2"],
  ["S21G0090_SL", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　5"],
  ["S21G0090_SM", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　4"],
  ["S21G0090_SN", "北１号館Ａ２０４／北１号館Ａ２０４", "火／Tue　5"],
  ["S21G0090_SO", "北１号館Ａ２０４／北１号館Ａ２０４", "金／Fri　3"],
  ["S21G0090_SQ", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　4"],
  ["S21G0090_SR", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　4"],
  ["S21G0100_Sj", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　4"],
  ["S21G0100_Sk", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　2"],
  ["S21G0100_Sl", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　5"],
  ["S21G0100_Sm", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　3"],
  ["S21G0100_Sn", "北１号館Ａ２０４／北１号館Ａ２０４", "月／Mon　5"],
  ["S21G0100_So", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　3"],
  ["S21G0100_Sq", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　4"],
  ["S21G0100_Sr", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　4"],
  ["S21G0110_SJ", "北３号館Ｂ１０１／北３号館Ｂ１０１", "火／Tue　1"],
  ["S21G0110_SK", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　2"],
  ["S21G0110_SL", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　5"],
  ["S21G0110_SM", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　4"],
  ["S21G0110_SN", "北１号館Ａ２０４／北１号館Ａ２０４", "火／Tue　5"],
  ["S21G0110_SO", "北１号館Ａ２０４／北１号館Ａ２０４", "金／Fri　3"],
  ["S21G0110_SQ", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　4"],
  ["S21G0110_SR", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　4"],
  ["S21G0120_Sj", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　4"],
  ["S21G0120_Sk", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　2"],
  ["S21G0120_Sl", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　5"],
  ["S21G0120_Sm", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　3"],
  ["S21G0120_Sn", "北１号館Ａ２０４／北１号館Ａ２０４", "月／Mon　5"],
  ["S21G0120_So", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　3"],
  ["S21G0120_Sq", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　4"],
  ["S21G0120_Sr", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　4"],
  ["S2200040_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "金／Fri　2"],
  ["S2200050_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "火／Tue　5"],
  ["S2200060_S6", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　2"],
  ["S2200210_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　2"],
  ["S2200290_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "月／Mon　3,　月／Mon　4"],
  ["S2200440_S6", "", "他／Otr"],
  ["S2200460_S6", "北１号館Ａ１０４／北１号館Ａ１０４", "月／Mon　5,　水／Wed　3"],
  ["S2200470_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "水／Wed　3,　水／Wed　4"],
  ["S2200560_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "木／Thu　3"],
  ["S2200581_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　1"],
  ["S2200590_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "月／Mon　4"],
  ["S2200660_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "水／Wed　1,　水／Wed　2"],
  ["S2200690_S6", "", "他／Otr"],
  ["S2200701_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　1"],
  ["S2200731_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "金／Fri　4"],
  ["S2200780_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "月／Mon　3,　月／Mon　4"],
  ["S2200871_S6", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　3,　月／Mon　4"],
  ["S2200880_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "金／Fri　1,　金／Fri　2"],
  ["S2200910_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "水／Wed　3"],
  ["S2200920_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "水／Wed　3"],
  ["S2200950_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "金／Fri　4"],
  ["S2200970_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "月／Mon　3,　月／Mon　4"],
  ["S2201000_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "水／Wed　1"],
  ["S2201010_S6", "北１号館Ａ２０２／北１号館Ａ２０２", "月／Mon　4,　月／Mon　5"],
  ["S2201070_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "火／Tue　2"],
  ["S2201080_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "火／Tue　2"],
  ["S2201120_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "月／Mon　2"],
  ["S2201140_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "月／Mon　3"],
  ["S2201150_S6", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　4"],
  ["S2201160_S6", "北１号館Ａ１０４／北１号館Ａ１０４", "火／Tue　4"],
  ["S2201170_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "火／Tue　1"],
  ["S2201210_S6", "北１号館Ａ２０４, 北３号館Ｂ２０３／北１号館Ａ２０４, 北３号館Ｂ２０３", "火／Tue　4"],
  ["S2201220_S6", "", "他／Otr"],
  ["S2201230_S6", "", "他／Otr"],
  ["S2201240_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "水／Wed　4"],
  ["S2201250_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "木／Thu　4"],
  ["S2201260_S6", "北３号館Ｂ１０１／北３号館Ｂ１０１", "月／Mon　2"],
  ["S2201270_S6", "", "他／Otr"],
  ["S2201310_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "水／Wed　1,　水／Wed　2"],
  ["S2201320_S6", "", "他／Otr"],
  ["S2201330_S6", "", "他／Otr"],
  ["S2201340_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "木／Thu　4"],
  ["S2201350_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "火／Tue　4,　木／Thu　4"],
  ["S2201360_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "火／Tue　3,　木／Thu　3"],
  ["S2201370_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "火／Tue　3,　木／Thu　3"],
  ["S2201380_S6", "北１号館Ａ２０２／北１号館Ａ２０２", "火／Tue　1"],
  ["S2201390_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "月／Mon　3"],
  ["S2201400_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "木／Thu　3"],
  ["S2201410_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "月／Mon　4"],
  ["S2201420_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "月／Mon　4"],
  ["S2201440_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "月／Mon　2"],
  ["S2201450_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "月／Mon　4"],
  ["S2201460_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "月／Mon　1"],
  ["S2201470_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "火／Tue　2"],
  ["S2201471_S6", "北３号館Ｂ２０２／北３号館Ｂ２０２", "木／Thu　3"],
  ["S2201472_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　3"],
  ["S2201473_S6", "北３号館Ｂ２０３／北３号館Ｂ２０３", "水／Wed　3"],
  ["S2201476_S6", "北１号館Ａ２０３／北１号館Ａ２０３", "火／Tue　2,　金／Fri　2"],
  ["S2201477_S6", "北１号館Ａ２０４／北１号館Ａ２０４", "木／Thu　2"],
  ["S2201478_S6", "学術情報センター第１演習室（西５号館）／学術情報センター第１演習室（西５号館）", "水／Wed　3"],
  ["S2300040_SJ", "", "他／Otr"],
  ["S2300040_SK", "", "他／Otr"],
  ["S2300040_SL", "", "他／Otr"],
  ["S2300040_SM", "", "他／Otr"],
  ["S2300040_SN", "", "他／Otr"],
  ["S2300040_SO", "", "他／Otr"],
  ["S2300040_SQ", "", "他／Otr"],
  ["S2300040_SR", "", "他／Otr"],
  ["S2300050_Sj", "", "他／Otr"],
  ["S2300050_Sk", "", "他／Otr"],
  ["S2300050_Sl", "", "他／Otr"],
  ["S2300050_Sm", "", "他／Otr"],
  ["S2300050_Sn", "", "他／Otr"],
  ["S2300050_So", "", "他／Otr"],
  ["S2300050_Sq", "", "他／Otr"],
  ["S2300050_Sr", "", "他／Otr"],
  ["S2300060_SJ", "", "他／Otr"],
  ["S2300060_SK", "", "他／Otr"],
  ["S2300060_SL", "", "他／Otr"],
  ["S2300060_SM", "", "他／Otr"],
  ["S2300060_SN", "", "他／Otr"],
  ["S2300060_SO", "", "他／Otr"],
  ["S2300060_SQ", "", "他／Otr"],
  ["S2300060_SR", "", "他／Otr"],
  ["S2300070_Sj", "", "他／Otr"],
  ["S2300070_Sk", "", "他／Otr"],
  ["S2300070_Sl", "", "他／Otr"],
  ["S2300070_Sm", "", "他／Otr"],
  ["S2300070_Sn", "", "他／Otr"],
  ["S2300070_So", "", "他／Otr"],
  ["S2300070_Sq", "", "他／Otr"],
  ["S2300070_Sr", "", "他／Otr"],
  ["S3000004_SJ", "", "他／Otr"],
  ["S3000004_Sj", "", "他／Otr"],
  ["S3000004_SK", "", "他／Otr"],
  ["S3000004_Sk", "", "他／Otr"],
  ["S3000004_SL", "", "他／Otr"],
  ["S3000004_Sl", "", "他／Otr"],
  ["S3000004_SM", "", "他／Otr"],
  ["S3000004_Sm", "", "他／Otr"],
  ["S3000004_SN", "", "他／Otr"],
  ["S3000004_Sn", "", "他／Otr"],
  ["S3000004_SO", "", "他／Otr"],
  ["S3000004_So", "", "他／Otr"],
  ["S3000004_SQ", "", "他／Otr"],
  ["S3000004_Sq", "", "他／Otr"],
  ["S3000004_SR", "", "他／Otr"],
  ["S3000004_Sr", "", "他／Otr"],
  ["S3000005_SJ", "", "他／Otr"],
  ["S3000005_Sj", "", "他／Otr"],
  ["S3000005_SK", "", "他／Otr"],
  ["S3000005_Sk", "", "他／Otr"],
  ["S3000005_SL", "", "他／Otr"],
  ["S3000005_Sl", "", "他／Otr"],
  ["S3000005_SM", "", "他／Otr"],
  ["S3000005_Sm", "", "他／Otr"],
  ["S3000005_SN", "", "他／Otr"],
  ["S3000005_Sn", "", "他／Otr"],
  ["S3000005_SO", "", "他／Otr"],
  ["S3000005_So", "", "他／Otr"],
  ["S3000005_SQ", "", "他／Otr"],
  ["S3000005_Sq", "", "他／Otr"],
  ["S3000005_SR", "", "他／Otr"],
  ["S3000005_Sr", "", "他／Otr"],
  ["S3000006_SJ", "", "他／Otr"],
  ["S3000006_Sj", "", "他／Otr"],
  ["S3000006_SK", "", "他／Otr"],
  ["S3000006_Sk", "", "他／Otr"],
  ["S3000006_SL", "", "他／Otr"],
  ["S3000006_Sl", "", "他／Otr"],
  ["S3000006_SM", "", "他／Otr"],
  ["S3000006_Sm", "", "他／Otr"],
  ["S3000006_SN", "", "他／Otr"],
  ["S3000006_Sn", "", "他／Otr"],
  ["S3000006_SO", "", "他／Otr"],
  ["S3000006_So", "", "他／Otr"],
  ["S3000006_SQ", "", "他／Otr"],
  ["S3000006_Sq", "", "他／Otr"],
  ["S3000006_SR", "", "他／Otr"],
  ["S3000006_Sr", "", "他／Otr"],
  ["S3000007_SJ", "", "他／Otr"],
  ["S3000007_Sj", "", "他／Otr"],
  ["S3000007_SK", "", "他／Otr"],
  ["S3000007_Sk", "", "他／Otr"],
  ["S3000007_SL", "", "他／Otr"],
  ["S3000007_Sl", "", "他／Otr"],
  ["S3000007_SM", "", "他／Otr"],
  ["S3000007_Sm", "", "他／Otr"],
  ["S3000007_SN", "", "他／Otr"],
  ["S3000007_Sn", "", "他／Otr"],
  ["S3000007_SO", "", "他／Otr"],
  ["S3000007_So", "", "他／Otr"],
  ["S3000007_SQ", "", "他／Otr"],
  ["S3000007_Sq", "", "他／Otr"],
  ["S3000007_SR", "", "他／Otr"],
  ["S3000007_Sr", "", "他／Otr"],
  ["S3000008_SJ", "", "他／Otr"],
  ["S3000008_Sj", "", "他／Otr"],
  ["S3000008_SK", "", "他／Otr"],
  ["S3000008_Sk", "", "他／Otr"],
  ["S3000008_SL", "", "他／Otr"],
  ["S3000008_Sl", "", "他／Otr"],
  ["S3000008_SM", "", "他／Otr"],
  ["S3000008_Sm", "", "他／Otr"],
  ["S3000008_SN", "", "他／Otr"],
  ["S3000008_Sn", "", "他／Otr"],
  ["S3000008_SO", "", "他／Otr"],
  ["S3000008_So", "", "他／Otr"],
  ["S3000008_SQ", "", "他／Otr"],
  ["S3000008_Sq", "", "他／Otr"],
  ["S3000008_SR", "", "他／Otr"],
  ["S3000008_Sr", "", "他／Otr"],
  ["T2T10112_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　2"],
  ["T2T10113_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "火／Tue　3"],
  ["T2T10114_T1", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "水／Wed　4"],
  ["T2T10115_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "木／Thu　2"],
  ["T2T10116_T1", "", "他／Otr"],
  ["T2T10117_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　3"],
  ["T2T10118_T1", "", "他／Otr"],
  ["T2T10119_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "木／Thu　4"],
  ["T2T10120_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "月／Mon　4"],
  ["T2T10121_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "水／Wed　2"],
  ["T2T10122_T1", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "水／Wed　5"],
  ["T2T10123_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "木／Thu　5"],
  ["T2T10124_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "水／Wed　1"],
  ["T2T10125_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "金／Fri　3"],
  ["T2T10126_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "金／Fri　3"],
  ["T2T10127_T1", "", "他／Otr"],
  ["T2T10128_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "水／Wed　3"],
  ["T2T10129_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "水／Wed　3"],
  ["T2T10130_T1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "金／Fri　2"],
  ["T2T10131_T1", "西４号館Ｋ２０６／K206", "木／Thu　2"],
  ["T2T10132_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　3"],
  ["T2T10133_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　4"],
  ["T2T10134_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "火／Tue　4"],
  ["T2T10135_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "火／Tue　3"],
  ["T2T10136_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "水／Wed　5"],
  ["T2T10137_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "他／Otr"],
  ["T2T10138_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "火／Tue　3"],
  ["T2T10139_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "火／Tue　4"],
  ["T2T10140_T1", "", "他／Otr"],
  ["T2T10141_T1", "", "他／Otr"],
  ["T2T10142_TZ", "", "他／Otr"],
  ["T2T10143_T1", "", "金／Fri　1"],
  ["T2T20002_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20002_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20002_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Te", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tk", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tn", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_To", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_Tt", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20007_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Te", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tk", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tn", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_To", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_Tt", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20008_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20013_T1", "", "他／Otr"],
  ["T2T20014_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Te", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Tn", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_To", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_Tt", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T2T20014_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T10001_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_E1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_E2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_E3", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_Tn", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_To", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_Tv", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T3T20001_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T4T10004_T1", "西４号館Ｔ１０１／T101", "火／Tue　3,　火／Tue　4"],
  ["T4T10018_T1", "西４号館Ｔ１０１／T101", "火／Tue　3,　火／Tue　4"],
  ["T4T10033_T1", "北３号館Ｂ１０１／北３号館Ｂ１０１", "水／Wed　1,　水／Wed　2"],
  ["T4T10048_T1", "西４号館Ｔ１０１／T101", "木／Thu　3,　木／Thu　4"],
  ["T4T10056_T1", "東１号館Ｅ１-２０３／E1-203", "水／Wed　3,　水／Wed　4"],
  ["T4T10067_T1", "西４号館Ｔ１０１／T101", "水／Wed　1,　水／Wed　2"],
  ["T4T10071_T1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　1,　木／Thu　2"],
  ["T4T10128_TZ", "", "他／Otr"],
  ["T4T10129_TZ", "", "他／Otr"],
  ["T4T10130_TZ", "", "他／Otr"],
  ["T4T10171_T1", "西４号館Ｔ１０１／T101", "他／Otr"],
  ["T4T10173_T1", "西４号館Ｔ１０１／T101", "木／Thu　3,　木／Thu　4"],
  ["T4T10187_T1", "西４号館Ｔ１０１／T101", "水／Wed　1,　水／Wed　2"],
  ["T4T10378_T1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　3,　水／Wed　4"],
  ["T4T10382_T1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "金／Fri　3,　金／Fri　4"],
  ["T4T10417_T1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　3,　水／Wed　4"],
  ["T4T10418_T1", "東１号館Ｅ１-１０２／E1-102", "火／Tue　3,　火／Tue　4"],
  ["T4T10419_T1", "東１号館Ｅ１-１０３／E1-103", "水／Wed　3,　水／Wed　4"],
  ["T4T10420_T1", "西４号館Ｔ１０１／T101", "他／Otr"],
  ["T4T10422_T1", "", "他／Otr"],
  ["T4T10426_T1", "西４号館Ｔ１０１／T101", "月／Mon　3,　月／Mon　4"],
  ["T4T10427_T1", "西４号館Ｔ１０１／T101", "月／Mon　1,　月／Mon　2"],
  ["T4T10428_Tm", "西４号館Ｔ１０１／T101", "水／Wed　3,　水／Wed　4"],
  ["T4T10428_Ts", "東１号館Ｅ１-３０３／E1-303", "水／Wed　3,　水／Wed　4"],
  ["T4T10431_T1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "水／Wed　2"],
  ["T4T10433_T1", "西４号館Ｔ１０１／T101", "月／Mon　1,　月／Mon　2"],
  ["T4T10434_T1", "西４号館Ｔ１０１／T101", "月／Mon　1,　月／Mon　2"],
  ["T4T10435_T1", "西４号館Ｔ１０１／T101", "月／Mon　1,　月／Mon　2"],
  ["T4T10441_T1", "西４号館Ｔ１０１／T101", "金／Fri　1,　金／Fri　2"],
  ["T4T10442_T1", "北１号館Ａ１０３／北１号館Ａ１０３", "木／Thu　1,　木／Thu　2"],
  ["T4T10446_T1", "西４号館Ｔ１０１／T101", "水／Wed　3,　水／Wed　4"],
  ["T4T10447_T1", "東１号館Ｅ１-１０３／E1-103", "月／Mon　3,　月／Mon　4"],
  ["T4T10450_T1", "東２号館Ｌ２０１／東２号館Ｌ２０１", "木／Thu　1,　木／Thu　2"],
  ["T4T10453_T1", "東１号館Ｅ１-２０６／E1-206", "火／Tue　3,　火／Tue　4"],
  ["T4T10455_T1", "西４号館Ｔ１０１／T101", "火／Tue　1,　火／Tue　2"],
  ["T4T10459_T1", "西４号館Ｔ１０１／T101", "金／Fri　3,　金／Fri　4"],
  ["T4T10461_T1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　3,　月／Mon　4"],
  ["T4T10472_T1", "東１号館Ｅ１-３０５／E1-305", "水／Wed　1,　水／Wed　2"],
  ["T4T10473_T1", "西４号館Ｔ１０１／T101", "他／Otr"],
  ["T4T10475_T1", "西４号館Ｔ１０１／T101", "水／Wed　3,　水／Wed　4"],
  ["T4T10477_T1", "西４号館Ｔ１０１／T101", "火／Tue　3,　火／Tue　4"],
  ["T4T10479_TZ", "", "他／Otr"],
  ["T4T10480_TZ", "", "他／Otr"],
  ["T4T10481_TZ", "", "他／Otr"],
  ["T4T10482_TZ", "", "他／Otr"],
  ["T4T10483_TZ", "", "他／Otr"],
  ["T4T10484_TZ", "", "他／Otr"],
  ["T4T10485_TZ", "", "他／Otr"],
  ["T4T10486_TZ", "", "他／Otr"],
  ["T4T10487_TZ", "", "他／Otr"],
  ["T4T10488_TZ", "", "他／Otr"],
  ["T4T10489_TZ", "", "他／Otr"],
  ["T4T10490_TZ", "", "他／Otr"],
  ["T4T10491_TZ", "", "他／Otr"],
  ["T4T10492_TZ", "", "他／Otr"],
  ["T4T10493_TZ", "", "他／Otr"],
  ["T4T10494_TZ", "", "他／Otr"],
  ["T4T10495_TZ", "", "他／Otr"],
  ["T4T10496_TZ", "", "他／Otr"],
  ["T4T10497_TZ", "", "他／Otr"],
  ["T4T10498_TZ", "", "他／Otr"],
  ["T4T10499_T1", "西４号館Ｔ１０１／T101", "金／Fri　2"],
  ["T4T10499_T2", "東１号館Ｅ１-２０５／E1-205", "金／Fri　3"],
  ["T4T10499_T8", "", "他／Otr"],
  ["T4T10499_Ta", "西４号館Ｋ２０８／K208", "火／Tue　4"],
  ["T4T10499_Tc", "東１号館Ｅ１-２０５／E1-205", "他／Otr"],
  ["T4T10499_Tj", "東１号館Ｅ１-２０５／E1-205", "月／Mon　5"],
  ["T4T10499_To", "西４号館Ｋ２０８／K208", "他／Otr"],
  ["T4T10499_Tv", "東１号館Ｅ１-２０６／E1-206", "他／Otr"],
  ["T4T10506_T1", "東１号館Ｅ１-１１３（旧学環）／E1-113", "火／Tue　3,　火／Tue　4"],
  ["T4T10509_T1", "西４号館Ｔ１０１／T101", "火／Tue　1,　火／Tue　2"],
  ["T4T10510_T1", "西４号館Ｔ１０１／T101", "月／Mon　3,　月／Mon　4"],
  ["T4T10516_T1", "西４号館Ｔ１０１／T101", "火／Tue　3,　火／Tue　4"],
  ["T4T10519_T1", "東１号館Ｅ１-２０３／E1-203", "金／Fri　3,　金／Fri　4"],
  ["T4T10520_T1", "東１号館Ｅ１-２０６／E1-206", "月／Mon　3,　月／Mon　4"],
  ["T4T10524_T1", "西４号館Ｔ１０１／T101", "金／Fri　3,　金／Fri　4"],
  ["T4T10544_T1", "東１号館Ｅ１-１０１／E1-101", "月／Mon　1,　月／Mon　2"],
  ["T4T10545_T1", "西４号館Ｔ１０１／T101", "月／Mon　3,　月／Mon　4"],
  ["T4T10547_T1", "西４号館Ｔ１０１／T101", "金／Fri　3,　金／Fri　4"],
  ["T4T10548_T1", "学術情報センター第３演習室（西５号館）／学術情報センター第３演習室（西５号館）", "水／Wed　3,　水／Wed　4"],
  ["T4T10550_T1", "東１号館Ｅ１-２０３／E1-203", "水／Wed　3,　水／Wed　4"],
  ["T4T10552_T1", "東１号館Ｅ１-１０２／E1-102", "月／Mon　3,　月／Mon　4"],
  ["T4T10579_TZ", "", "他／Otr"],
  ["T4T10614_T1", "東１号館Ｅ１-３０４／E1-304", "木／Thu　1"],
  ["T4T10615_T1", "東１号館Ｅ１-３０６／E1-306", "木／Thu　3"],
  ["T4T10616_T1", "東１号館Ｅ１-３０６／E1-306", "木／Thu　4"],
  ["T4T10617_T1", "西４号館Ｔ１０１／T101", "金／Fri　3,　金／Fri　4"],
  ["T4T10618_T1", "東１号館Ｅ１-３０５／E1-305", "金／Fri　3,　金／Fri　4"],
  ["T4T10619_T1", "東１号館Ｅ１-２０９／E1-209", "水／Wed　1,　水／Wed　2"],
  ["T4T10620_T1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　1,　水／Wed　2"],
  ["T4T10621_T1", "東１号館Ｅ１-３０６／E1-306", "木／Thu　5"],
  ["T4T10622_T1", "東１号館Ｅ１-２０６／E1-206", "月／Mon　2"],
  ["T4T10623_T1", "西４号館Ｋ２０８／K208", "木／Thu　3"],
  ["T4T10624_T1", "西４号館Ｋ２０８／K208", "他／Otr"],
  ["T4T10625_T1", "", "他／Otr"],
  ["T4T10626_T1", "西４号館Ｔ１０１／T101", "木／Thu　3,　木／Thu　4"],
  ["T4T10628_T1", "", "他／Otr"],
  ["T4T10631_T1", "西４号館Ｔ１０１／T101", "他／Otr"],
  ["T4T10633_TZ", "", "他／Otr"],
  ["T4T10634_TZ", "", "他／Otr"],
  ["T4T10635_TZ", "", "他／Otr"],
  ["T4T10636_TZ", "", "他／Otr"],
  ["T4T10637_TZ", "", "他／Otr"],
  ["T4T10638_TZ", "", "他／Otr"],
  ["T4T10639_TZ", "", "他／Otr"],
  ["T4T10640_TZ", "", "他／Otr"],
  ["T4T10645_TZ", "", "他／Otr"],
  ["T4T10646_TZ", "", "他／Otr"],
  ["T4T10647_TZ", "", "他／Otr"],
  ["T4T10648_TZ", "", "他／Otr"],
  ["T4T10649_TZ", "", "他／Otr"],
  ["T4T10650_TZ", "", "他／Otr"],
  ["T4T10651_TZ", "", "他／Otr"],
  ["T4T10652_TZ", "", "他／Otr"],
  ["T4T10653_TZ", "", "他／Otr"],
  ["T4T10654_TZ", "", "他／Otr"],
  ["T4T10655_TZ", "", "他／Otr"],
  ["T4T10656_TZ", "", "他／Otr"],
  ["T4T10657_TZ", "", "他／Otr"],
  ["T4T10658_TZ", "", "他／Otr"],
  ["T4T10659_TZ", "", "他／Otr"],
  ["T4T10660_TZ", "", "他／Otr"],
  ["T4T10661_TZ", "", "他／Otr"],
  ["T4T10662_TZ", "", "他／Otr"],
  ["T4T10663_TZ", "", "他／Otr"],
  ["T4T10664_TZ", "", "他／Otr"],
  ["T4T10669_TZ", "", "他／Otr"],
  ["T4T10670_TZ", "", "他／Otr"],
  ["T4T10671_TZ", "", "他／Otr"],
  ["T4T10672_TZ", "", "他／Otr"],
  ["T4T10673_TZ", "", "他／Otr"],
  ["T4T10674_TZ", "", "他／Otr"],
  ["T4T10675_TZ", "", "他／Otr"],
  ["T4T10676_TZ", "", "他／Otr"],
  ["T4T10677_TZ", "", "他／Otr"],
  ["T4T10678_TZ", "", "他／Otr"],
  ["T4T10679_TZ", "", "他／Otr"],
  ["T4T10680_TZ", "", "他／Otr"],
  ["T4T10681_TZ", "", "他／Otr"],
  ["T4T10682_TZ", "", "他／Otr"],
  ["T4T10683_TZ", "", "他／Otr"],
  ["T4T10684_TZ", "", "他／Otr"],
  ["T4T10685_T1", "東１号館Ｅ１-２０８／E1-208", "金／Fri　1,　金／Fri　2"],
  ["T4T10686_T1", "東１号館Ｅ１-２０３／E1-203", "金／Fri　1,　金／Fri　2"],
  ["T4T10687_T1", "東１号館Ｅ１-２０８／E1-208", "金／Fri　1,　金／Fri　2"],
  ["T4T10689_T1", "東１号館Ｅ１-３０５／E1-305", "火／Tue　3,　火／Tue　4"],
  ["T4T10691_T1", "東１号館Ｅ１-３０６／E1-306", "水／Wed　3,　水／Wed　4"],
  ["T4T10692_T1", "東１号館Ｅ１-３０６／E1-306", "火／Tue　3,　火／Tue　4"],
  ["T4T10693_T1", "東１号館Ｅ１-２０３／E1-203", "水／Wed　3,　水／Wed　4"],
  ["T4T10694_T1", "東１号館Ｅ１-２０９／E1-209", "月／Mon　1,　月／Mon　2"],
  ["T4T10695_T1", "東１号館Ｅ１-３０３／E1-303", "水／Wed　3,　水／Wed　4"],
  ["T4T10696_TZ", "", "他／Otr"],
  ["T4T10697_TZ", "", "他／Otr"],
  ["T4T10698_TZ", "", "他／Otr"],
  ["T4T10699_TZ", "", "他／Otr"],
  ["T4T10700_TZ", "", "他／Otr"],
  ["T4T10701_TZ", "", "他／Otr"],
  ["T4T10702_TZ", "", "他／Otr"],
  ["T4T10703_TZ", "", "他／Otr"],
  ["T4T10704_T1", "北１号館Ａ１０３／北１号館Ａ１０３", "水／Wed　3,　水／Wed　4"],
  ["T4T10705_T1", "東１号館Ｅ１-２０３／E1-203", "金／Fri　3,　金／Fri　4"],
  ["T4T10706_T1", "東１号館Ｅ１-１０２／E1-102", "水／Wed　3,　水／Wed　4"],
  ["T4T10719_T1", "", "他／Otr"],
  ["T4T10720_TZ", "", "他／Otr"],
  ["T4T10721_TZ", "", "他／Otr"],
  ["T4T10722_TZ", "", "他／Otr"],
  ["T4T10723_TZ", "", "他／Otr"],
  ["T4T10724_TZ", "", "他／Otr"],
  ["T4T10725_TZ", "", "他／Otr"],
  ["T4T10726_TZ", "", "他／Otr"],
  ["T4T10727_TZ", "", "他／Otr"],
  ["T4T10728_TZ", "", "他／Otr"],
  ["T4T10729_TZ", "", "他／Otr"],
  ["T4T10730_TZ", "", "他／Otr"],
  ["T4T10731_TZ", "", "他／Otr"],
  ["T6T10049_TZ", "", "他／Otr"],
  ["T6T10050_TZ", "", "他／Otr"],
  ["T6T10051_TZ", "", "他／Otr"],
  ["T6T10052_T1", "東１号館Ｅ１-２０１／E1-201", "火／Tue　3"],
  ["T6T10053_T1", "東１号館Ｅ１-３０４／E1-304", "火／Tue　2"],
  ["T6T10054_T1", "東１号館Ｅ１-３０６／E1-306", "月／Mon　3,　月／Mon　4"],
  ["T6T10054_T2", "東１号館Ｅ１-２０９／E1-209", "月／Mon　3,　月／Mon　4"],
  ["T6T10054_T3", "西４号館Ｔ１０１／T101", "月／Mon　3,　月／Mon　4"],
  ["T6T10055_T1", "西４号館Ｔ１０１／T101", "水／Wed　1,　水／Wed　2"],
  ["T6T10055_T2", "西４号館Ｔ１０１／T101", "水／Wed　3,　水／Wed　4"],
  ["T6T10055_T3", "東１号館Ｅ１-３０６／E1-306", "水／Wed　3,　水／Wed　4"],
  ["T6T10056_T1", "西４号館Ｔ１０１／T101", "火／Tue　1,　火／Tue　2"],
  ["T6T10057_T1", "大学会館２階和室／大学会館２階和室", "火／Tue　1,　火／Tue　2"],
  ["T6T10060_T1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "木／Thu　1,　木／Thu　2"],
  ["T6T10104_T1", "東１号館Ｅ１-１０３／E1-103", "木／Thu　1,　木／Thu　2"],
  ["T6T10105_T1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "木／Thu　1,　木／Thu　2"],
  ["T6T10106_T1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "木／Thu　1,　木／Thu　2"],
  ["T6T10108_TZ", "", "他／Otr"],
  ["T6T10109_TZ", "", "他／Otr"],
  ["T6T10110_TZ", "", "他／Otr"],
  ["T7T16003_T9", "東１号館Ｅ１-２０５／E1-205", "木／Thu　5"],
  ["T7T16003_Ta", "東１号館Ｅ１-３０３／E1-303", "木／Thu　5"],
  ["T7T16003_Tg", "東１号館Ｅ１-２１０／E1-210", "木／Thu　5"],
  ["T7T16003_Th", "東１号館Ｅ１-２０３／E1-203", "木／Thu　5"],
  ["T7T16003_Tj", "東１号館Ｅ１-２０６／E1-206", "木／Thu　5"],
  ["T7T16003_Tk", "東１号館Ｅ１-２０９／E1-209", "木／Thu　5"],
  ["T7T16003_Tm", "東１号館Ｅ１-３０４／E1-304", "木／Thu　5"],
  ["T7T16003_To", "東１号館Ｅ１-３０１／E1-301", "木／Thu　5"],
  ["T7T16003_Ts", "東１号館Ｅ１-２０１／E1-201", "木／Thu　5"],
  ["T7T16003_Tt", "東１号館Ｅ１-３０６／E1-306", "木／Thu　5"],
  ["T7T16003_Tw", "東１号館Ｅ１-２０８／E1-208", "木／Thu　5"],
  ["T7T16004_T1", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "金／Fri　5"],
  ["T7T16004_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "木／Thu　5"],
  ["T7T16004_T5", "東１号館Ｅ１-２１０／E1-210", "金／Fri　5"],
  ["T7T16004_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16004_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "月／Mon　5"],
  ["T7T16004_Ta", "西４号館Ｋ２０６／K206", "火／Tue　5"],
  ["T7T16004_Tb", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　5"],
  ["T7T16004_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "金／Fri　5"],
  ["T7T16004_Te", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "金／Fri　5"],
  ["T7T16004_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "火／Tue　5"],
  ["T7T16004_Tg", "西４号館Ｋ２０８／K208", "水／Wed　5"],
  ["T7T16004_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "金／Fri　5"],
  ["T7T16004_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16004_Tk", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16004_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "月／Mon　5"],
  ["T7T16004_Tn", "西４号館Ｋ２０８／K208", "木／Thu　5"],
  ["T7T16004_To", "東１号館Ｅ１-２０１／E1-201", "月／Mon　5"],
  ["T7T16004_Tt", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "火／Tue　5"],
  ["T7T16004_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr　5"],
  ["T7T16005_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tb", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Te", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tg", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tk", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tn", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_To", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_Tt", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16005_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16006_T1", "東１号館Ｅ１-２０５／E1-205", "水／Wed　5"],
  ["T7T16006_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "火／Tue　5"],
  ["T7T16006_T5", "東１号館Ｅ１-２１０／E1-210", "金／Fri　5"],
  ["T7T16006_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16006_Ta", "西４号館Ｋ２０６／K206", "水／Wed　5"],
  ["T7T16006_Tb", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "金／Fri　5"],
  ["T7T16006_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "木／Thu　5"],
  ["T7T16006_Te", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16006_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16006_Tg", "西４号館Ｋ２０８／K208", "月／Mon　5"],
  ["T7T16006_Th", "東１号館Ｅ１-２１０／E1-210", "水／Wed　5"],
  ["T7T16006_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "金／Fri　5"],
  ["T7T16006_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16006_Tn", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "水／Wed　5"],
  ["T7T16006_To", "東１号館Ｅ１-２０１／E1-201", "火／Tue　5"],
  ["T7T16006_Tt", "東１号館Ｅ１-２１０／E1-210", "月／Mon　5"],
  ["T7T16006_Tv", "東１号館Ｅ１-２０６／E1-206", "水／Wed　5"],
  ["T7T16006_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr　5"],
  ["T7T16009_T1", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tb", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Te", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tg", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tk", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tn", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_To", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_Tt", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16009_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T7T16013_T1", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "金／Fri　5"],
  ["T7T16013_T2", "西４号館担当教員研究室／西４号館担当教員研究室", "木／Thu　5"],
  ["T7T16013_T5", "東１号館Ｅ１-２１０／E1-210", "金／Fri　5"],
  ["T7T16013_T8", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16013_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "月／Mon　5"],
  ["T7T16013_Ta", "西４号館Ｋ２０６／K206", "火／Tue　5"],
  ["T7T16013_Tb", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　5"],
  ["T7T16013_Tc", "西４号館担当教員研究室／西４号館担当教員研究室", "金／Fri　5"],
  ["T7T16013_Te", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "金／Fri　5"],
  ["T7T16013_Tf", "西４号館担当教員研究室／西４号館担当教員研究室", "火／Tue　5"],
  ["T7T16013_Tg", "西４号館Ｋ２０８／K208", "水／Wed　5"],
  ["T7T16013_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "金／Fri　5"],
  ["T7T16013_Tj", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16013_Tk", "西４号館担当教員研究室／西４号館担当教員研究室", "水／Wed　5"],
  ["T7T16013_Tm", "西４号館担当教員研究室／西４号館担当教員研究室", "月／Mon　5"],
  ["T7T16013_Tn", "西４号館Ｋ２０８／K208", "木／Thu　5"],
  ["T7T16013_To", "東１号館Ｅ１-２０１／E1-201", "月／Mon　5"],
  ["T7T16013_Tt", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "火／Tue　5"],
  ["T7T16013_TZ", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr　5"],
  ["T8T10001_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　1"],
  ["T8T10002_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　3"],
  ["T8T10003_T1", "", "他／Otr"],
  ["T8T10004_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　2"],
  ["T8T10005_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　3"],
  ["T8T10006_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "火／Tue　3"],
  ["T8T10007_T1", "学術情報センター第２演習室（西５号館）／学術情報センター第２演習室（西５号館）", "金／Fri　1"],
  ["T8T10008_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　2"],
  ["T8T10009_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "金／Fri　4"],
  ["T8T10010_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "火／Tue　2"],
  ["T8T10011_T1", "東１号館Ｅ１-１１２（面談室）／E1-112", "火／Tue　3"],
  ["T8T10012_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　4"],
  ["T8T10014_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　2"],
  ["T8T10015_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "木／Thu　5"],
  ["T8T10016_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "月／Mon　4"],
  ["T8T10017_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　5"],
  ["T8T10018_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "月／Mon　5"],
  ["T8T10019_T1", "西４号館Ｋ２０８／K208", "水／Wed　4"],
  ["T8T10020_T1", "東１号館Ｅ１-３０２キャンパススクエア３／E1-302Campus square3", "火／Tue　5"],
  ["T8T10021_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　5"],
  ["T8T10022_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "水／Wed　4"],
  ["T8T10024_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "火／Tue　4,　火／Tue　5"],
  ["T8T10025_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "火／Tue　3,　火／Tue　4"],
  ["T8T10027_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "木／Thu　4,　木／Thu　5"],
  ["T8T10028_T1", "東１号館Ｅ１-２０７キャンパススクエア２／E1-207Campus square2", "金／Fri　2"],
  ["T8T10029_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "金／Fri　3"],
  ["T8T10030_T1", "東１号館Ｅ１-２０４キャンパススクエア１／E1-204Campus square1", "木／Thu　4,　木／Thu　5"],
  ["T8T20001_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Tb", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Tg", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Tp", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Tq", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Tr", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20001_Tv", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Tb", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Tg", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Tp", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Tq", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Tr", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20002_Tv", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Tb", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Tg", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Tp", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Tq", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Tr", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20003_Tv", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_T5", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_T9", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Ta", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Tb", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Tg", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Th", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Tp", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Tq", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Tr", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
  ["T8T20004_Tv", "西４号館担当教員研究室／西４号館担当教員研究室", "他／Otr"],
];

const ignoreList = ["その他", "図書館セミナールーム４（西５号館）", "体育関連施設", "体育館（アリーナ）"];

// シラバスから抽出したデータを、扱いやすくするために加工する
const processScheduleData = (scheduleData: RawScheduleData): ProcessedScheduleItem[] => {
  const processedData: ProcessedScheduleItem[] = [];

  scheduleData.forEach(([courseCode, classrooms, schedules]) => {
    const processedClassrooms = classrooms.split("／")[0].split(",");
    const scheduleList = schedules.split(",");

    scheduleList.forEach((schedule) => {
      const [day, time] = schedule.split("／");
      processedClassrooms.forEach((classroom) => {
        if (ignoreList.includes(classroom)) return;
        processedData.push({
          courseCode,
          classroom,
          day: day,
          time: time.slice(-1),
        });
      });
    });
  });

  // sort by room name
  const sortedProcessedData = [...processedData].sort((a, b) => a.classroom.localeCompare(b.classroom));

  return sortedProcessedData;
};

// データを処理して、エクスポートする
const scheduleData = processScheduleData(NotProcessedScheduleData);

export default scheduleData;
